
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { OptionTranslateService } from '../../../../shared/services/option-translate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AddConsigneeComponent } from "./add-consignee/add-consignee.component";
import { environment } from '../../../../../environments/environment';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { SharedService } from '../../../../shared/services/shared.service';
import { Utils } from '../../../../Utils/utils';
import { DocumentServiceType, FieldValue, ServiceName, SrActionType, SrIOName, UserType } from '../../../../shared/constants/services.enum';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { ApiService } from '../../../../core/services/api.service';
import { AttachmentService } from '../../../../core/services/attachment.service';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { OptionFieldComponent } from '../../../../shared/components/controls/option-field/option-field.component';
import { TextFieldComponent } from '../../../../shared/components/controls/text-field/text-field.component';
import { CooPayload } from '../../../../shared/models/services-request/issue-new-coo.model';
import { SrSubmitSuccessModalComponent } from "../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { CooQueryRequest } from './models/coo-query-request.model';
import { fieldMapping } from './models/sr-mapping-object.model';
import { CooListRequest } from './models/coo-list-request.model';
import { CardCarouselComponent } from "../../../../shared/components/card-carousel/card-carousel.component";
import { AddCarnetProductComponent } from "../ata-carnet/add-carnet-product/add-carnet-product.component";
import { LovSelectionService } from '../../../../core/services/lov-selection.service';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { AccountModel } from '../../../../shared/models/loginuser.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { customValidator } from '../../../../Utils/validator';
import { FolderResponse, AllowedDocumentType } from '../../../../shared/models/documents-response.model';
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { lastValueFrom, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HSCodeRequest } from '../../../../shared/models/hs-code-request.model';
import { DateComponent } from '../../../../shared/components/controls/date/date.component';
import { MobileNumberComponent } from '../../../../shared/components/controls/mobile-number/mobile-number.component';
import { ActiveMembershipsComponent } from "../../../../shared/components/active-memberships/active-memberships.component";
import { DocumentName } from '../../../../shared/constants/documents-name.enum';
import {
  InvoiceOcrComponent,
  InvoiceOcrExtractedProduct,
  InvoiceOcrExtractionResult
} from './invoice-ocr/invoice-ocr.component';
import { EncryptionResponse } from '../../../../shared/models/encryption-response.model';

interface InvoiceOcrTransferPayload {
  invoiceNo: string;
  invoiceDate: {
    day: string;
    month: string;
    year: string;
  };
  invCurrency: string;
  invAmount: string;
  shippingFrom: string | null;
  countryDest: string | null;
  portOfDischarge: string | null;
  products: any[];
  startStep?: number;
}

@Component({
  selector: 'app-certificate-of-origin',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ...SHARED_COMPONENTS,
    AddConsigneeComponent,
    SrSubmitSuccessModalComponent,
    CardCarouselComponent,
    AddCarnetProductComponent,
    SkeletonLoaderComponent,
    FormsModule,
    ActiveMembershipsComponent,
    InvoiceOcrComponent
  ],
  templateUrl: './certificate-of-origin.component.html',
  styleUrl: './certificate-of-origin.component.scss',
})
export class CertificateOfOriginComponent implements OnInit, OnDestroy {
  private static readonly INVOICE_OCR_TRANSFER_KEY = 'coo_invoice_ocr_transfer';
  private static readonly OCR_AUTO_UPLOAD_DOCUMENT_TYPE = 'COO_Invoice';
  private static readonly OCR_AUTO_UPLOAD_STAMP_LOCATION = 'C';
  private static readonly AMENDMENT_NOTICE_SESSION_KEY = 'coo_amendment_fee_notice_seen';
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  @ViewChildren(OptionFieldComponent) optionFields!: QueryList<OptionFieldComponent>;
  @ViewChildren(TextFieldComponent) textFields!: QueryList<TextFieldComponent>;
  @ViewChildren(DateComponent) dateFields!: QueryList<DateComponent>;
  @ViewChildren(MobileNumberComponent) mobileFields!: QueryList<MobileNumberComponent>;
  hsCodeRequest: HSCodeRequest = new HSCodeRequest();

  lookupKey = LookupKey;
  documentServiceType = DocumentServiceType;
  fieldValue = FieldValue;
  servicePath: 'issue-coo' | 'amendment-coo' | 'personal' | 'gsp-certificate' = 'issue-coo';
  allFields: any = [];
  form: FormGroup;
  private additionalDetailsValueChangesSub?: Subscription;
  lang: string = 'en';
  membershipId: any = 'm1';
  exporters: any = [];
  consigneeList: any = [];

  standardOption: any = [];
  addProductModal: boolean = false;
  countries: any = [];
  openConsigneeModal: boolean = false;
  step = 1;
  totalSteps = 5;
  stampPositions: any = [];
  memberships: AccountModel[] = [];
  products: any = [];
  userLoginName: string = "";
  userCSN: any = "";
  srNumber: any = "";
  loginUserDetail: any = "";
  srType: string = "";
  srSubType: string = "";
  canAddEdit: boolean = true;
  copyFromSr: string = "";
  userType: string = "";
  serviceTitle: string = "SR_ISSUE_COO";
  srInprgoressAwating: boolean = false;
  showNotes: boolean = false;
  showPreviewModal: boolean = false;
  previewUrl?: SafeResourceUrl;
  restrictedWordsList: any = [];
  motLovList: any = [];
  showConfirmExtractedInvoice: boolean = false;
  canEditInvoiceOcrFields: boolean = false;
  showInvoiceOcrInvoiceMismatchModal: boolean = false;
  showAmendmentFeeNoticeModal: boolean = false;
  private pendingInvoiceOcrFilesForUpload: File[] = [];
  private isAutoUploadingInvoiceOcrFiles: boolean = false;
  OCRProductHSCode: any[] = [];
  loadingOcrProductHsLookup: boolean = false;
  invoiceOcrMissingValidationMessages: { [key: string]: string } = {};
  showInvoiceOcrProductFallbackGuidance: boolean = false;
  productValidationErrorKey: string = '';
  showInvoiceOcrMissingProductCountryWarning: boolean = false;
  private docAiScanFlag: 'Y' | 'N' = 'N';
  private ocrExtractedInvoiceNumber: string = '';
  private acknowledgedOcrInvoiceNumberMismatch: string = '';

  // This method is used to initialize the class instance using router, fb, route, shared service, option translate service, api, and lov service
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private optionTranslateService: OptionTranslateService,
    private api: ApiService,
    private attachmentService: AttachmentService,
    private lovService: LovSelectionService,
    private sanitizer: DomSanitizer
  ) {

    this.lang = this.sharedService.getCurrentLang();
    this.loginUserDetail = this.sharedService.getUserProfile();
    this.userType = this.sharedService.getPrimaryAccount()?.['Account Type Code'];
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.userCSN = this.sharedService.getCsnAccountId('csn');

    this.form = this.fb.group({
      membershipId: [''],
      remember: [false],
      searchCooNumber: ['', [customValidator('safeText')]],
      searchProductText: ['', customValidator('safeText')],
      cooNumber: ['', [Validators.maxLength(15), customValidator('safeText')]],
      exporter: [null, [Validators.required]],
      exporterType: [null, [Validators.required]],
      consignee: [null, [Validators.required]],
      consigneeType: [null, [Validators.required]],
      invoiceNo: [null, [Validators.maxLength(50), customValidator('safeText')]],
      invoiceDate: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      invCurrency: [null, [Validators.required]],
      invAmount: ['', [Validators.required, Validators.maxLength(30), Validators.min(0.01)]],
      directShip: [null],
      shippingFrom: [null],
      transportMode: [null, [Validators.required]],
      exitPoint: [null],
      countryDest: [null, [Validators.required]],
      stampPosition: [null],
      portOfDischarge: [null],
      confirmExtractedInvoice: [false],
      expectedDepartureDate: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      requiredCOO: [''],
      additionalDetails: ['', [Validators.maxLength(1000), customValidator('safeText')]],
      products: [null, [Validators.required]],
      paymentMethod: [null, [Validators.required]],
      GSPAuthorizedPerson: [null],
      attestationRequired: [],
      signatory: []
    });
    const additionalDetailsControl = this.form.get('additionalDetails');
    this.additionalDetailsValueChangesSub = additionalDetailsControl?.valueChanges.subscribe((value: string | null) => {
      this.validateAdditionalDetailsField(value);
    });

    this.route.data.subscribe(data => {
      this.servicePath = data['mode'];
    });

    this.initializeInvoiceOcrValidationMessages();
    this.setInitialValues();
    this.registerInvoiceOcrMissingFieldListeners();
  }

  ngOnInit(): void {
    // Call the function to disbale fields
    Utils.disableFieldsBasedOnSubService(this.servicePath, this.form);
    if (!this.srNumber) {
      this.initializeAmendmentFeeNoticeModal();
    }
    this.syncInvoiceOcrFieldAccess();
    this.applyPendingInvoiceOcrTransfer();

    this.openFolder();
    if (!this.srNumber) {
      this.getExporterList();
      if (this.step == 1) {
        this.getCOOList();
      }
    }
    this.getCurrencyList();
  }

  private initializeAmendmentFeeNoticeModal(): void {
    if (!this.isAmendmentCOO) {
      return;
    }

    this.showAmendmentFeeNoticeModal =
      sessionStorage.getItem(CertificateOfOriginComponent.AMENDMENT_NOTICE_SESSION_KEY) !== 'true';
  }

  closeAmendmentFeeNoticeModal(): void {
    this.showAmendmentFeeNoticeModal = false;
    sessionStorage.setItem(CertificateOfOriginComponent.AMENDMENT_NOTICE_SESSION_KEY, 'true');
  }
  // This method is used to check if issue coo
  get isIssueCOO(): boolean {
    return this.servicePath === 'issue-coo';
  }
  // This method is used to check if amendment coo
  get isAmendmentCOO(): boolean {
    return this.servicePath === 'amendment-coo'
  }
  // This method is used to check if personal use
  get isPersonalUse(): boolean {
    return this.servicePath === 'personal';
  }
  // This method is used to check if gsp certificate
  get isGspCertificate(): boolean {
    return this.servicePath === 'gsp-certificate';
  }

  get isInvoiceOcrEnabled(): boolean {
    return !this.isPersonalUse && !this.isAmendmentCOO;
  }

  loadDataBasedOnSrMember() {
    this.getExporterList();
    this.getMemberSignatory()
    if (this.isGspCertificate == true) {
      this.getauthorizedPerson();
    }
  }
  // This method is used to set initial values
  setInitialValues() {
    this.currentSrStatus = '';
    this.initialInvoiceNoForValidation = '';
    this.srType = ServiceName.COO;
    this.srSubType = ServiceName.ISSUE_NEW_COO;
    let fieldsToRequired: any = [
      "invoiceNo",
      "invoiceDate.day",
      "invoiceDate.month",
      "invoiceDate.year",
      "directShip",
      "exitPoint",
      "products",
      "paymentMethod"
    ];
    if (this.isIssueCOO == true) {
      this.toggleRequired(true, fieldsToRequired);
    }
    if (this.isAmendmentCOO == true) {
      this.srSubType = ServiceName.AMENDMENT_COO;
      this.serviceTitle = "SR_AMD_COO";
      this.toggleRequired(true, fieldsToRequired);
    }
    if (this.isGspCertificate == true) {
      this.srSubType = ServiceName.ISSUE_GSP_COO;
      this.serviceTitle = "SR_ISSUE_GSP_CERTIFICATE";
      if (!this.srNumber) {
        this.getauthorizedPerson();
      }
      fieldsToRequired.push("GSPAuthorizedPerson");
      this.toggleRequired(true, fieldsToRequired);
    }
    if (this.isPersonalUse == true) {
      this.srSubType = ServiceName.PERSONAL_EFFECTS_COO;
      this.serviceTitle = "SR_PERSONAL_COO";
      this.step = 3;
      let pefFRequired = [
        "transportMode",
        "products",
        "paymentMethod"
      ];
      this.toggleRequired(true, pefFRequired)
    }

    // SR Number in the url
    const routeSrNumber = this.route.snapshot.params?.['sr_no'];
    const routeCsn = this.route.snapshot.params?.['csn'];
    if (routeCsn) {
      this.userCSN = routeCsn;
      this.membershipId = routeCsn;
    }
    if (routeSrNumber) {
      this.srNumber = routeSrNumber;
    }
    this.route.params.subscribe(params => {
      if (params['csn']) {
        this.userCSN = params['csn'];
        this.membershipId = params['csn'];
      }
      if (params['sr_no']) {
        this.srNumber = params['sr_no'];
        this.getSRDetail();
      }
      this.route.queryParams.subscribe(query => {
        if (query && query['csr'] != null) {
          this.copyFromSr = query['csr'];
          this.getSRDetail(true);
        }
      })

    });
    // in case of draft
    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber ? storeSrNumber : "";
      this.getSRDetail();
    }

    //only for Member
    if (this.isIssueCOO || this.isAmendmentCOO || this.isGspCertificate) {
      this.getActiveMembership();
      if (this.userType != UserType.MEMBER) {
        this.sharedService.toastMessage('INFO', 'ONLY_MEMBER_ALLOWED', 'info', true);
        this.router.navigate([RoutesPath.DASHBOARD]);
        return;
      }

      // let accountLicenseIssueAuthority = this.sharedService.getPrimaryAccount()["DC License Issue Authority"];
      // if (accountLicenseIssueAuthority && accountLicenseIssueAuthority == FieldValue.WITHOUT_LICENSE) {
      //   this.sharedService.toastMessage('INFO', 'WITHOUT_LICENSE_NOTALLOWED', 'info', true);
      //   this.router.navigate([RoutesPath.DASHBOARD]);
      //   return;
      // }

      // check for Professional / Service License
      let account = this.sharedService.getPrimaryAccount();
      if (!this.validateLicenseEligibility(account)) {
        return;
      }

      if (this.memberships.length < 1) {
        this.sharedService.toastMessage('INFO', 'NO_ACTIVE_MEMBERSHIP', 'info', true);
        this.router.navigate([RoutesPath.DASHBOARD]);
        return;
      }
    }

    // only for non-member
    if (this.isPersonalUse) {
      if (this.userType == UserType.MEMBER) {
        this.sharedService.toastMessage('INFO', 'ONLY_NON_MEMBER_ALLOWED', 'info', true);
        this.router.navigate([RoutesPath.DASHBOARD]);
        return;
      }
    }

    //get LOV for Mode of transport
    this.getAddtionRestrictedWords(true);

    const lang = (localStorage.getItem('selectedLang') as 'en' | 'ar') || 'en';
    this.standardOption = this.optionTranslateService.getOptions(
      'standardOption',
      lang
    );
    this.stampPositions = this.optionTranslateService.getOptions(
      'stampPositions',
      lang
    );
    if (this.srSubType != ServiceName.PERSONAL_EFFECTS_COO) {
      this.getMasterHsCode();
    }

    this.getAddtionRestrictedWords();
  }

  // This method is used to get active membership
  getActiveMembership() {
    this.membershipId = this.userCSN;
    let accounts: any = Utils.checkIsArray(this.loginUserDetail?.Account);
    const filteredAccounts = accounts.filter((acc: any) => {
      // must have CSN
      if (!acc.CSN || acc.CSN.trim() === '') {
        return false;
      }
      // must not be inactive
      if (this.sharedService.isInactiveMemberAccount(acc)) {
        return false;
      }
      let accountLicenseType = acc["DC License Type"];
      let accountLicenseIssueAuthority = acc["DC License Issue Authority"];
      // must not have Offshore License
      if (accountLicenseType == FieldValue.OFFSHORE_LICENSE
        || accountLicenseType == FieldValue.OFFSHORE_LICENSE_AR
        // || accountLicenseType == FieldValue.PROFESSIONAL_LICENSE
        // || accountLicenseType == FieldValue.SERVICE_LICENSE
        // || accountLicenseIssueAuthority == FieldValue.WITHOUT_LICENSE
      ) {
        return false;
      }
      // use common method for membership expiry validation
      return Utils.isMembershipValid(acc["DC Expiry Date"]);
    });

    this.memberships = filteredAccounts;

    // If selected for future
    if (filteredAccounts && filteredAccounts.length > 1) {
      if (sessionStorage.getItem("isFutureRemember")) {
        let remObj: any = sessionStorage.getItem("isFutureRemember");
        let futureRemember: any = JSON.parse(remObj);
        let member = filteredAccounts.find((m: any) => m.CSN == futureRemember.CSN);
        if (member) {
          this.setSelectedMemberShip(member);
          this.step = 2;
        } else {
          this.membershipId = "";
          this.userCSN = "";
        }
      }
    }

    if (!(filteredAccounts?.find((m: any) => m.CSN == this.userCSN))) {
      this.membershipId = "";
      this.userCSN = "";
    }
  }

  // This method is used to set selected member ship using member
  async setSelectedMemberShip(member: any) {
    this.membershipId = "";
    this.userCSN = "";
    let accountLicenseType = member["DC License Type"];
    let accountLicenseIssueAuthority = member["DC License Issue Authority"];
    // must not have Offshore License      
    if (accountLicenseType && accountLicenseType == FieldValue.OFFSHORE_LICENSE
      || accountLicenseType == FieldValue.OFFSHORE_LICENSE_AR
    ) {
      // || accountLicenseIssueAuthority == FieldValue.WITHOUT_LICENSE
      this.sharedService.toastMessage('INFO', 'OFFSHORE_LICENSE_NOTALLOWED', 'info', true);
      return;
    } else {
      const memberCSN = member?.CSN || '';
      // for professional license, need to check activities for the member and set in shared service for future use
      if (memberCSN && accountLicenseType == FieldValue.PROFESSIONAL_LICENSE) {
        const activities = await this.getMemberActivitiesByCsn(memberCSN);
        this.sharedService.setPrimaryMemberActivities(activities);
      }

      if (!this.validateLicenseEligibility(member)) {
        return;
      } else {
        let memberCSN = member.CSN;
        this.membershipId = memberCSN;
        this.userCSN = memberCSN;
        this.sharedService.setPrimaryAccount(member);
        this.form.get('membershipId')?.setValue(memberCSN);

        if (this.isAmendmentCOO || this.isIssueCOO && this.step == 1) {
          this.getCOOList();
        }
        this.getExporterList();
        if (this.isGspCertificate) {
          this.getauthorizedPerson();
        }
      }
    }

  }

  // This method is used to get member activities by csn and return activities array
  private async getMemberActivitiesByCsn(csn: string): Promise<any[]> {
    if (!csn) {
      return [];
    }
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get Member Details Web WF",
        "IOName": "DC Get Acc Details IO",
        "CSN": csn
      }
    };
    try {
      const response: any = await lastValueFrom(
        this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_MEMBER_DETAIL_BY_CSN, requestPayload)
      );
      if (response?.["Error Code"] === "" && response?.["Error Message"] === "") {
        const memberData = response?.SiebelMessage?.['DC Account Data Transfer'];
        const activities = Utils.checkIsArray(memberData?.["DC Account Activity"]);
        return activities || [];
      }
    } catch {
    }
    return [];
  }

  validateLicenseEligibility(
    account: any
  ): boolean {
    //Professional license type
    const memberActivities = this.sharedService.getPrimaryMemberActivities() || [];
    const professionalLicenseAllowedActivityCodes = ['5210002', 'I630203', 'G515101'];
    let accountLicenseType = account['DC License Type'];
    if (accountLicenseType === FieldValue.PROFESSIONAL_LICENSE) {
      const exceptionFlag = account["DC COO Exception"];
      if (exceptionFlag == "Y") {
        return true;
      }
      const hasAllowedActivityCode = memberActivities.some((activity: any) => {
        const activityCode = (activity?.['DC Activity Code'] || '').toString().trim().toUpperCase();
        return professionalLicenseAllowedActivityCodes.includes(activityCode);
      });
      if (hasAllowedActivityCode) {
        return true;
      }

      this.sharedService.toastMessage(
        'INFO',
        'PROFESSIONAL_SERVICE_LICENSE_NOTALLOWED',
        'info',
        true
      );
      this.router.navigate([RoutesPath.DASHBOARD]);
      return false;
    }

    //Servcie license type
    // if (accountLicenseType === FieldValue.SERVICE_LICENSE) {
    //   this.sharedService.toastMessage(
    //     'INFO',
    //     'SERVICE_LICENSE_NOT_ALLOWED_TO_APPLY',
    //     'info',
    //     true
    //   );
    //   this.router.navigate([RoutesPath.DASHBOARD]);
    //   return false;
    // }
    return true;
  }



  // This method is used to set for future using value
  setForFuture(value: any) { }

  selectMembershipError: boolean = false;
  // This method is used to start new application
  startNow() {
    if (this.membershipId) {
      if (this.form.get('remember')?.value == true) {
        let obj = { CSN: this.userCSN, rememberFuture: true }
        sessionStorage.setItem("isFutureRemember", JSON.stringify(obj))
      }
      this.step = 2;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.selectMembershipError = true;
    }
  }
  // This method is used to change membership
  changeMembership() {
    this.step = 1;
  }
  cooIntegrationList: any = [];
  cooListLoading: boolean = false;
  pageSize: number = 4;
  totalCOORecords: number = 0;
  pageIndex: number = 1;
  // This method is used to search
  search() {
    const value = this.form.get('searchCooNumber')?.value?.trim() || '';
    if (value) {
      this.pageIndex = 1;
      this.getCOOList();
    }
  }
  // This method is used to remove search using event
  removeSearch(event: KeyboardEvent) {
    const value = this.form.get('searchCooNumber')?.value?.trim() || '';
    if (value === '') {
      this.pageIndex = 1;
      this.getCOOList();
    }
  }

  // This method is used to page change using page
  onCooListPageChange(page: any) {
    this.pageIndex = page;
    this.cooIntegrationList = []
    this.getCOOList();
  }
  // This method is used to get coo list
  getCOOList() {
    this.totalCOORecords = 0;
    this.cooListLoading = true;
    this.cooIntegrationList = [];
    let req = new CooListRequest();
    req.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();

    const searchValue = this.form.get('searchCooNumber')?.value || '';
    const isSrNumber = searchValue.startsWith('1-');

    req.body.IncomingHierarchy.ListOfDCCOOListIO["DC COO SR Thin BC"]["Account Number"] = this.userCSN;
    req.body.IncomingHierarchy.ListOfDCCOOListIO["DC COO SR Thin BC"]["DC COO Number"] = isSrNumber ? '' : searchValue;
    req.body.IncomingHierarchy.ListOfDCCOOListIO["DC COO SR Thin BC"]["SR Number"] = isSrNumber ? searchValue : '';

    req.body.Language = this.lang == "ar" ? "ARA" : "ENU";
    req.body.PageSize = "5";
    req.body.StartRowNum = 5 * (this.pageIndex - 1);
    req.body.NewQuery = this.pageIndex === 1;
    req.body.NoDays = "100";

    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_COO_LIST,
      req
    ).subscribe({
      next: (response: any) => {
        this.cooListLoading = false;
        if (response?.SiebelMessage && response['Error Code'] == null && response["Error Message"] == null || response["Error Message"] == "") {
          this.totalCOORecords = response["TotalRecords"]
          this.cooIntegrationList = response.SiebelMessage["DC COO SR Thin BC"];
        }
      },
      error: () => {
        this.cooListLoading = false;
      }
    })

  }
  // This method is used to copy coo sr to new using selected row
  copyCOOSrToNew(selectedRow: any) {
    this.copyFromSr = selectedRow['SR Number'];
    if (this.isAmendmentCOO) {
      this.form.get("cooNumber")?.setValue(selectedRow['DC COO Number']);
    }
    this.getSRDetail(true);
  }
  // This method is used to get exporter list
  getExporterList() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Exporter List WF",
        "MemberNum": this.userCSN,
        "DCLanguage": this.lang == 'ar' ? 'ARA' : 'ENU'
      }
    }
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.COO_GET_EXPORTER, requestPayload)
      .subscribe({
        next: (response: any) => {
          if (response && response.SiebelMessage?.Account) {
            let account = response.SiebelMessage?.Account;
            let list = Utils.checkIsArray(response.SiebelMessage.Account?.["Party Relationship To"]);

            this.exporters = [
              // Push the main Account as group title
              {
                Name: this.lang == "ar" ? account["DC Name Arabic"] : account["DC Name English"],
                Value: account.Id,
                CSN: account["CSN"],
                isGroupTitle: true
              },
              // Push related parties as normal entries
              ...list.map(rel => ({
                ...rel,
                Name: this.lang == "ar" ? rel["DC Related Party Name Arabic"] : rel["DC Related Party Name English"],
                Value: rel["Related Party Id"], //rel["Id"],
                CSN: rel["DC Membership Number"],
                isGroupTitle: false
              }))
            ];
            if (this.exporters && this.exporters.length > 0 && !this.copyFromSr) {
              if (this.isPersonalUse) {
                this.form.get("exporter")?.setValue(this.exporters[0].Name);
              } else {
                if (!this.srNumber) {
                  this.form.get("exporter")?.setValue(this.exporters[0].Value);
                }
              }
              if (!this.srNumber) {
                this.exporterMemberNumber = this.exporters[0].CSN;
              }
            }
          }
        },
        error: () => {

        }
      })
    this.getConsigneeList();
  }
  // This method is used to get consignee list
  getConsigneeList() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Consignee List WF",
        "AccountNumber": this.userCSN,
        "ConsigneeNameEng": "",
        "Language": this.lang == "ar" ? "ARA" : "ENU"
      }
    }
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.COO_GET_COSIGNEE_LIST, requestPayload)
      .subscribe({
        next: (response: any) => {
          if (response && response.SiebelMessage?.Account) {
            let list = Utils.checkIsArray(response.SiebelMessage.Account?.["DC Account Consignee Details"]);
            this.consigneeList = list.map((consignee) => {

              // const address = consignee["DC Address 1"];
              const addressParts = [
                consignee['DC Address 1'],
                consignee['DC Address 2'],
                consignee['DC Address 3'],
              ].filter(addr => addr != null && addr !== '');

              const address = addressParts.join(', ');

              const country = consignee["DC Consignee Country"];

              const addressCountry = address ? `${address}, ${country}` : country;
              const name =
                this.lang === "ar"
                  ? (consignee["DC Consignee Name Arabic"] ||
                    consignee["DC Consignee Name English"])
                  : consignee["DC Consignee Name English"];

              return {
                ...consignee,
                Name: `${name} (${addressCountry})`,
                Value: consignee["DC Consignee Id"]
              };
            })
          }

        },
        error: () => {

        }
      })
  }

  currencyList: any = [];
  // This method is used to get currency list
  getCurrencyList() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Currency List WF",
        "CurrencyCode": ""
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration, ApiEndPoints.GET_CURRENCY_LIST,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response.SiebelMessage?.Currency) {
          let list = Utils.checkIsArray(response.SiebelMessage?.Currency);
          this.currencyList = list.map((item: any) => ({
            ...item,
            Name: item.Name,
            Value: item["Currency Code"]
          }));
        }
        if (!this.srNumber) {
          this.getMemberSignatory();
        }
      }
    })
  }

  // get signatory list
  authorizedPersonList: any = [];
  // This method is used to get authorized person
  getauthorizedPerson() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get List of Signatory Mob App WF",
        "IncomingHierarchy": {
          "MessageId": Utils.generateUniqueId(),
          "IntObjectName": "DCGetSignatoryIO",
          "MessageType": "Integration Object",
          "IntObjectFormat": "Siebel Hierarchical",
          "ListOfDCGetSignatoryIO": {
            "Account": {
              "CSN": this.userCSN,
            }
          }
        },
        "SR Sub Type": ServiceName.ISSUE_GSP_COO
      }
    }
    this.api.post<any, any>(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.VERIFY_SIGNATURE,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response?.SiebelMessage && response['Error Code'] == null && response["Error Message"] == null || response["Error Message"] == "") {
          let list = Utils.checkIsArray(response.SiebelMessage.Account?.["Party Relationship To"]);

          this.authorizedPersonList = [
            ...list.map(rel => ({
              ...rel,
              Name: this.lang === 'ar' ? rel['DC Related Party Name Arabic'] : rel['DC Related Party Name English'],
              Value: this.lang === 'ar' ? rel['DC Related Party Name Arabic'] : rel['DC Related Party Name English'],
            }))
          ];
        }
      },
      error: () => {
      }
    })
  }

  isDupliateInNumber: boolean = false;
  private invoiceValidationRequestId: number = 0;
  private invoiceValidationInFlight: Promise<boolean> | null = null;
  private lastInvoiceValidationKey: string = '';
  private lastInvoiceValidationResult: boolean = true;
  private currentSrStatus: string = '';
  private initialInvoiceNoForValidation: string = '';
  // This method is used to validate invocie number using value
  async validateInvocieNumber(value: any): Promise<boolean> {
    const invoiceNo = this.form.get('invoiceNo')?.value?.trim();
    const invoiceDate = this.form.get('invoiceDate')?.value;
    // Prevent API call if missing invoice number or date
    if (!invoiceNo || !invoiceDate?.day || !invoiceDate?.month || !invoiceDate.year) {
      this.lastInvoiceValidationKey = '';
      this.lastInvoiceValidationResult = true;
      this.isDupliateInNumber = false;
      return true;
    }
    if (this.isAmendmentCOO || this.isPersonalUse) {
      this.lastInvoiceValidationKey = '';
      this.lastInvoiceValidationResult = true;
      this.isDupliateInNumber = false;
      return true;
    }

    if (this.shouldSkipInvoiceValidationForAwaitingClarification(invoiceNo)) {
      this.lastInvoiceValidationKey = '';
      this.lastInvoiceValidationResult = true;
      this.isDupliateInNumber = false;
      return true;
    }

    const validationKey = `${this.userCSN}|${invoiceNo}|${invoiceDate.month}/${invoiceDate.day}/${invoiceDate.year}`;
    if (validationKey === this.lastInvoiceValidationKey) {
      if (this.invoiceValidationInFlight) {
        return this.invoiceValidationInFlight;
      }
      this.isDupliateInNumber = !this.lastInvoiceValidationResult;
      return this.lastInvoiceValidationResult;
    }

    const requestId = ++this.invoiceValidationRequestId;
    this.lastInvoiceValidationKey = validationKey;
    this.isDupliateInNumber = false;
    let invDate: string = `${invoiceDate.month}/${invoiceDate.day}/${invoiceDate.year}`;
    let requestPayload = {
      "body": {
        "ProcessName": "DC Check Duplicate COO Invoice Number WF",
        "vMemNum": this.userCSN,
        "vInvDate": invDate,
        "vInvNum": invoiceNo
      }
    }
    const validationPromise = (async (): Promise<boolean> => {
      try {
        const response: any = await lastValueFrom(
          this.api.post(
            ApiRoot.DCCICPIntegration,
            ApiEndPoints.VALIDATE_COO_INVOICE_NUMBER,
            requestPayload
          )
        );
        if (requestId !== this.invoiceValidationRequestId) {
          this.isDupliateInNumber = !this.lastInvoiceValidationResult;
          return this.lastInvoiceValidationResult;
        }
        const hasErrorCode = !!response?.["Error Code"];
        const hasErrorMessage = !!response?.["Error Message"];
        this.isDupliateInNumber = hasErrorCode || hasErrorMessage;
      } catch {
        if (requestId !== this.invoiceValidationRequestId) {
          this.isDupliateInNumber = !this.lastInvoiceValidationResult;
          return this.lastInvoiceValidationResult;
        }
        this.isDupliateInNumber = false;
      }
      this.lastInvoiceValidationResult = !this.isDupliateInNumber;
      return this.lastInvoiceValidationResult;
    })();

    this.invoiceValidationInFlight = validationPromise;
    try {
      return await validationPromise;
    } finally {
      if (this.invoiceValidationInFlight === validationPromise) {
        this.invoiceValidationInFlight = null;
      }
    }
  }

  private shouldSkipInvoiceValidationForAwaitingClarification(invoiceNo: string): boolean {
    const status = (this.currentSrStatus || '').toString().trim().toLowerCase();
    const awaitingClarification = status === SrStatus.AwaitingClarification.toLowerCase() || status === 'awaiting clarification';
    if (!awaitingClarification) {
      return false;
    }
    const currentInvoiceNo = (invoiceNo || '').toString().trim();
    return currentInvoiceNo === this.initialInvoiceNoForValidation;
  }

  exporterMemberNumber: string = "";
  // This method is used to handle exporter change event using option
  onExporterChange(option: any) {
    if (option?.selectedLov) {
      this.exporterMemberNumber = option?.selectedLov["CSN"];
    }
  }

  // This method is used to handle directship change event using option
  onDirectshipChange(option: any) {
    let directShipment = option == FieldValue.YES || option == FieldValue.YES_AR ? true : false
    this.toggleRequired(directShipment, ["shippingFrom"]);
    this.updateDocumentMandatory();
    this.setExpointValue(directShipment);
  }

  setExpointValue(directShipment: boolean = false) {
    let exitPointControl = this.form.get('exitPoint');
    if (directShipment) {
      let value = this.lang == 'ar' ? FieldValue.DIRECT_SHIPMENT_AR : FieldValue.DIRECT_SHIPMENT;
      exitPointControl?.setValue(value);
      exitPointControl?.disable();
      exitPointControl?.updateValueAndValidity();
    } else {
      exitPointControl?.enable();
    }
  }

  checkForExportCountry(option: any) {
    if (option?.selectedLov) {
      if (option?.selectedLov.Name == FieldValue.UAE || option?.selectedLov.Value == FieldValue.UAE || option?.selectedLov.Value == FieldValue.UAE_AR) {
        this.form.get('shippingFrom')?.setValue(null);
        this.sharedService.toastMessage('ERROR', 'SHIPPING_FROM_CANNOT_UAE', 'error', true);
      }
    }
  }

  selectedModeOfTransfer: any = "";
  // This method is used to handle transport mode change event using event
  onTransportModeChange(event: any) {
    const sel = event?.selectedLov;
    const rawName = (sel?.Name || '').toString();
    const rawLabel = (sel?.Value || '').toString();
    // Map display labels to API values: By Air->Air, By Sea->Sea, (optionally) By Land->Land
    let mot: string | null = null;
    if (/^\s*By\s+Air\s*$/i.test(rawLabel) || rawName === 'Air' || rawName === 'By Air' || rawName === "عبر الجو") {
      mot = 'Air';
    } else if (/^\s*By\s+Sea\s*$/i.test(rawLabel) || rawName === 'Sea' || rawName === 'By Sea' || rawName == "عبر البحر") {
      mot = 'Sea';
    } else if (/^\s*By\s+Lan(d)?\s*$/i.test(rawLabel) || rawName === 'Land' || rawName === 'By Land' || rawName === "عبر البر") {
      mot = 'Land';
    } else if (rawName === 'By Air/Sea' || rawName === "جواً / بحراً") {
      mot = 'Air';
    }
    else if (rawName === 'By Courier' || rawName === "عن طريق البريد") {
      mot = 'Courier';
    }
    this.selectedModeOfTransfer = mot;
    if (mot) {
      this.showCooDocs = true;
      this.openFolderMot(mot);
    } else {
      this.showCooDocs = false;
      this.srFolder = undefined as any;
      this.mainFromSectionDocs = [];
    }
  }
  loadingDoc: boolean = false;
  private previousVehicleProductState: boolean | null = null;
  private readonly personalRtaDocumentNameEn = DocumentName.PERSONAL_COO_RTA;

  // This method is used to open folder mot using coo mot
  private openFolderMot(cooMot: string) {
    const isLabels = !this.srNumber;
    let dsType = DocumentServiceType.COO;
    if (this.isPersonalUse) {
      dsType = DocumentServiceType.COO_PERSONAL
    }
    if (this.isGspCertificate || this.isPersonalUse || cooMot === 'Courier') {
      cooMot = "";
    }
    this.loadingDoc = true;
    this.sharedService
      .getDocuments(this.srNumber, dsType, isLabels, { cooMot })
      .subscribe({
        next: (response: any) => {
          if (response.success == true) {
            this.srFolder = response.data ? response.data : response;
            if(this.srFolder?.allowedDocumentTypes && this.srFolder?.allowedDocumentTypes?.length > 0) {
              this.loadingDoc = false; 
              this.mainFromSectionDocs = this.srFolder.allowedDocumentTypes?.filter((d: any) => !d.forUISection);
              this.previousVehicleProductState = this.hasVehiclePersonalProduct();
              this.updateDocumentMandatory()
              this.tryAutoUploadInvoiceOcrFiles();
            }
          }
        }
      });
  }
  // This method is used to update document mandatory
  updateDocumentMandatory(isProductCategoryChange: boolean = false) {
    const directShipValue = this.form.get('directShip')?.value;
    const hasVehicleProduct = this.hasVehiclePersonalProduct();
    const shouldShowRtaDoc = !this.isPersonalUse || hasVehicleProduct;
    const shouldRemoveRtaUploadedDoc =
      this.isPersonalUse
      && isProductCategoryChange
      && this.previousVehicleProductState === true
      && hasVehicleProduct === false;

    if (shouldRemoveRtaUploadedDoc) {
      this.removePersonalRtaDocumentUpload();
    }

    const markDirectShip = (doc: AllowedDocumentType) => {
      const withOriginal = this.withOriginalMandatory(doc);
      if (doc.nameEn === "Air Waybill" || doc.nameEn === "Bill of Lading") {
        return {
          ...withOriginal,
          mandatory: directShipValue == FieldValue.YES || directShipValue == FieldValue.YES_AR ? true : false
        };
      }
      if (this.isRtaDocument(withOriginal)) {
        return {
          ...withOriginal,
          mandatory: this.isPersonalUse ? hasVehicleProduct : withOriginal.mandatory
        };
      }
      return withOriginal;
    };

    if (this.srFolder?.allowedDocumentTypes?.length) {
      this.srFolder.allowedDocumentTypes = this.srFolder.allowedDocumentTypes.map((doc: AllowedDocumentType) => {
        const updatedDoc = markDirectShip(doc);
        if (!shouldShowRtaDoc && this.isRtaDocument(updatedDoc)) {
          return { ...updatedDoc, mandatory: false };
        }
        return updatedDoc;
      });
    }

    // Always derive visible docs from the full allowed list so hidden docs can re-appear later.
    const allSectionDocs = (this.srFolder?.allowedDocumentTypes || [])
      .filter((doc: AllowedDocumentType) => !doc.forUISection);
    this.mainFromSectionDocs = allSectionDocs
      .filter((doc: AllowedDocumentType) => shouldShowRtaDoc || !this.isRtaDocument(doc));
    this.previousVehicleProductState = hasVehicleProduct;
  }

  private withOriginalMandatory(doc: any): AllowedDocumentType {
    if ((doc as any)._originalMandatory !== undefined) {
      return doc;
    }
    return { ...doc, _originalMandatory: doc.mandatory };
  }

  private isRtaDocument(doc: { nameEn?: string } | null | undefined): boolean {
    const nameEn = (doc?.nameEn || '').toString().trim().toLowerCase();
    return nameEn === this.personalRtaDocumentNameEn.toLowerCase();
  }

  private hasVehiclePersonalProduct(): boolean {
    if (!this.isPersonalUse) {
      return false;
    }
    const vehiclesEn = FieldValue.VEHICLES.toLowerCase();
    const vehiclesAr = FieldValue.VEHICLES_AR.toLowerCase();
    return (this.products || []).some((product: any) => {
      const type = (product?.cooPersonalEffectType || '').toString().trim().toLowerCase();
      return type === vehiclesEn || type === vehiclesAr;
    });
  }

  private removePersonalRtaDocumentUpload(): void {
    if (!this.srFolder?.documents?.length) {
      return;
    }
    const rtaDocuments = this.srFolder.documents.filter((doc: any) =>
      this.isRtaDocument({ nameEn: doc.documentType })
    );
    if (!rtaDocuments.length) {
      return;
    }

    const documentIds = rtaDocuments
      .map((doc: any) => doc.documentId)
      .filter((id: any) => !!id);
    if (!documentIds.length) {
      return;
    }

    const data = {
      "documentServiceType": DocumentServiceType.COO_PERSONAL,
      "mot": this.selectedModeOfTransfer,
      "svsSubject": "",
      "folderId": this.srFolder.folderId,
      "folderParentId": this.srFolder.folderParentId,
      "folderParentType": this.srFolder.folderParentType,
      "documentId": documentIds
    };
    this.sharedService.deleteBulkDocument(data);
    this.srFolder.documents = this.srFolder.documents.filter(
      (doc: any) => !documentIds.includes(doc.documentId)
    );
  }

  private hasUaeOriginProduct(): boolean {
    const uaeEn = FieldValue.UAE.toLowerCase();
    const uaeAr = FieldValue.UAE_AR.toLowerCase();
    return (this.products || []).some((product: any) => {
      const country = (product?.country ?? '').toString().trim().toLowerCase();
      if (!country) {
        return false;
      }
      return country === uaeEn || country === uaeAr || country === 'uae' || country === 'united arab emirates';
    });
  }
  //get folder id and attachments
  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];
  showCooDocs: boolean = false;
  // This method is used to open folder
  openFolder() {
    // Evaluate current transport mode; only Air/Sea/Land should fetch docs
    const currentMot = this.form?.get('transportMode')?.value as string | null;
    const allowed = ['Air', 'Sea', 'Land', 'Courier'
    ];
    let modeOfTransfer = "Air";

    if (currentMot == "By Sea") {
      modeOfTransfer = "Sea"
    }
    if (currentMot == "By Land") {
      modeOfTransfer = "Land"
    }
    if (currentMot == "By Air/Sea") {
      modeOfTransfer = "Air"
    }
    if (currentMot == "By Courier") {
      modeOfTransfer = "Courier"
    }

    if (currentMot && allowed.includes(modeOfTransfer)) {
      this.showCooDocs = true;
      this.openFolderMot(modeOfTransfer);
      return;
    } else {
      this.showCooDocs = false;
      this.srFolder = undefined as any;
      this.mainFromSectionDocs = [];
      return;
    }
  }
  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    // If there are no docs to check, nothing is missing
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];

    // ViewChildren not ready or not fully rendered yet – defer document checks
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }

    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      // Safety guard; should not happen due to length check above
      if (!cmp) continue;

      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }
  selectedConsigneesLists: any = [];
  // This method is used to fill consigne detail using option
  fillConsigneDetail(option: any) {
    this.selectedConsigneesLists = [];
    this.dischargePorts = [];
    if (option?.selectedLov) {
      const jId: any = Utils.generateUniqueId();
      let cObj = option?.selectedLov ? option?.selectedLov : "";
      let object = {
        id: cObj["DC Consignee Id"],
        name: cObj["DC Consignee Name English"],
        // nameAr: cObj["DC Consignee Name English"],
        country: cObj["DC Consignee Country"] ?? "",
        city: cObj["DC City"],
        countryCode: cObj["DC Consignee Phone"] ? Utils.parseMobile(cObj["DC Consignee Phone"], 'cc') : "",
        phone: cObj["DC Consignee Phone"] ? Utils.parseMobile(cObj["DC Consignee Phone"], 'number') : "",
        address: cObj["DC Address 1"],
        poBox: cObj["DC PO Box Number"],
        fax: cObj["DC Consignee Fax"]
      }
      const newJourney = this.createConsObject(object, this.selectedConsigneesLists.length, cObj["DC Consignee Id"]);
      this.selectedConsigneesLists = [...this.selectedConsigneesLists, newJourney]; // also reassign here

      this.form.get("countryDest")?.setValue(cObj["DC Consignee Country"] ?? null);
      this.form.get("countryDest")?.updateValueAndValidity();
      if (option.selectedLov) {
        this.getDischagePort(cObj["DC Consignee Country"]);
      }
    } else {
      this.selectedConsigneesLists = [];
      this.form.get("countryDest")?.setValue(null);
      this.form.get("countryDest")?.updateValueAndValidity();
    }
  }

  dischargePorts: any = [];
  // This method is used to get dischage port using parent value
  getDischagePort(parentValue: any) {
    let request = {
      body: {
        ProcessName: "DC Get List Of Values WF",
        Type: LookupKey.COO_DC_PORT_DISCHRG,
        "LanguageCode": this.sharedService.getCurrentLang() == "ar" ? 'ARA' : "ENU",
        ParentValue: parentValue || ''
      }
    }
    this.api
      .post(ApiRoot.DCCICPIntegration, LookupKey.LOOKUP_URL, request)
      .subscribe({
        next: (result: any) => {
          if (result.SiebelMessage?.['List Of Values'] && result["Error Message"] == null || result["Error Message"] == "") {
            this.dischargePorts = Utils.checkIsArray(result.SiebelMessage['List Of Values']);
          }
        }
      })
  }
  selectedConsignee: any = null;
  // This method is used to handle consignee action event using event
  onConsigneeAction(event: any) {
    if (event.type == "edit") {
      this.selectedConsignee = event.data;
      this.openConsigneeModal = true;
      this.toggleRequired(false, ["consignee"]);
    } else {
      this.selectedConsigneesLists = this.selectedConsigneesLists?.filter((j: any) => j.id != event.data.id);
      this.form.get("consignee")?.setValue(this.selectedConsigneesLists.length > 0 ? 'Added' : "");
      this.form.get("consignee")?.updateValueAndValidity();
      this.selectedConsignee = "";
      this.selectedConsigneesLists = [];
    }
  }

  // This method is used to create cons object using consigne form detail, index, and id
  private createConsObject(consigneFormDetail: any, index: number, id: any) {
    return {
      id: id,
      formFields: consigneFormDetail,
      fields: [
        { label: 'COO.CONSIGNEE_FORM.NAME', value: consigneFormDetail.name },
        { label: 'COO.CONSIGNEE_FORM.COUNTRY', value: consigneFormDetail.country },
        { label: 'COO.CONSIGNEE_FORM.CITY', value: consigneFormDetail.city },
        { label: 'COO.CONSIGNEE_FORM.ADDRESS', value: consigneFormDetail.address },
        { label: "", value: consigneFormDetail.poBox },
        { label: "", value: consigneFormDetail.fax },
      ]
    };
  }
  // This method is used to handle add consignee event using data
  onAddConsignee(data: any) {
    if (this.selectedConsignee && this.selectedConsignee != null) {
      const index = this.selectedConsigneesLists.findIndex((j: any) => j.id === this.selectedConsignee?.id);
      if (index !== -1) {
        this.selectedConsigneesLists[index] = this.createConsObject(data, index, this.selectedConsignee?.id);
        this.selectedConsigneesLists = [...this.selectedConsigneesLists]; // <-- triggers change detection
      }
    } else {
      const jId: any = 0; //Utils.generateUniqueId();
      const newJourney = this.createConsObject(data, this.selectedConsigneesLists.length, jId);
      this.selectedConsigneesLists = [...this.selectedConsigneesLists, newJourney]; // also reassign here
    }
    this.form.get("countryDest")?.setValue(data["country"] ?? "");
    this.form.get("countryDest")?.updateValueAndValidity();

    this.form.get("consignee")?.setValue(this.selectedConsigneesLists.length > 0 ? 'Added' : "");
    this.form.get("consignee")?.updateValueAndValidity();

    this.getDischagePort(data["country"]);
  }

  // This method is used to handle destination change event using option
  onDestinationChange(option: any) {
    if (option.selectedLov) {
      this.lovService.setLovSelection(LookupKey.COUNTRY, option.selectedLov);
    }
  }
  // This method is used to toggle required using condition and controls
  private toggleRequired(condition: boolean, controls: string[]): void {
    Utils.addRemoveValidation(this.form, condition, controls);
  }

  private shouldBlockInvoiceDetailsProgress(): boolean {
    if (!this.isInvoiceOcrEnabled || this.step < 3) {
      return false;
    }

    const invoiceNo = (this.form.get('invoiceNo')?.value || '').toString().trim();
    const invoiceDate = this.form.get('invoiceDate')?.value;
    const invAmount = (this.form.get('invAmount')?.value || '').toString().trim();
    const directShip = this.form.get('directShip')?.value;
    const transportMode = this.form.get('transportMode')?.value;
    const exitPoint = this.form.get('exitPoint')?.value;
    const shippingFrom = this.form.get('shippingFrom')?.value;
    const portOfDischarge = this.form.get('portOfDischarge')?.value;
    const requiresShippingFrom = directShip == FieldValue.YES || directShip == FieldValue.YES_AR;

    const hasIncompleteInvoiceDetails = !invoiceNo
      || !invoiceDate?.day
      || !invoiceDate?.month
      || !invoiceDate?.year
      || !invAmount
      || !directShip
      || !transportMode;
    // || !exitPoint
    // || (requiresShippingFrom && !shippingFrom)
    // || !portOfDischarge;

    if (!hasIncompleteInvoiceDetails) {
      return false;
    }

    return !this.showConfirmExtractedInvoice || !this.canEditInvoiceOcrFields || hasIncompleteInvoiceDetails;
  }

  private focusInvoiceDetailsForCompletion() {
    [
      'invoiceNo',
      'invoiceDate',
      'invAmount',
      'directShip',
      'transportMode',
      'exitPoint',
      'shippingFrom',
      'portOfDischarge'
    ].forEach((controlName) => {
      this.form.get(controlName)?.markAsTouched();
      this.form.get(controlName)?.markAsDirty();
      this.form.get(controlName)?.updateValueAndValidity();
    });

    this.form.get('invoiceDate.day')?.markAsTouched();
    this.form.get('invoiceDate.month')?.markAsTouched();
    this.form.get('invoiceDate.year')?.markAsTouched();

    Utils.focusFirstInvalidControl(this.form, this.allFields);
  }

  private shouldShowInvoiceOcrUploadGuidance(): boolean {
    if (!this.isInvoiceOcrEnabled || this.step < 3) {
      return false;
    }

    const invoiceNo = (this.form.get('invoiceNo')?.value || '').toString().trim();
    const invoiceDate = this.form.get('invoiceDate')?.value;
    const invAmount = (this.form.get('invAmount')?.value || '').toString().trim();
    return !invoiceNo
      || !invoiceDate?.day
      || !invoiceDate?.month
      || !invoiceDate?.year
      || !invAmount;
  }

  private shouldShowCopyInvoiceOcrSubmitGuidance(): boolean {
    if (!this.isInvoiceOcrEnabled || !this.copyFromSr) {
      return false;
    }

    const invoiceNo = (this.form.get('invoiceNo')?.value || '').toString().trim();
    return !invoiceNo;
  }

  private scrollToInvoiceOcrBox() {
    const invoiceOcrElement = document.getElementById('invoice-ocr-box');
    if (!invoiceOcrElement) {
      return;
    }

    invoiceOcrElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  private shouldBlockConfirmExtractedInvoiceProgress(): boolean {
    if (this.step !== 5 || !this.isInvoiceOcrEnabled || !this.showConfirmExtractedInvoice) {
      return false;
    }

    return this.form.get('confirmExtractedInvoice')?.value !== true;
  }

  private shouldShowInvoiceOcrInvoiceMismatchModal(): boolean {
    if (!this.isInvoiceOcrEnabled || !this.showConfirmExtractedInvoice) {
      return false;
    }

    const extractedInvoiceNo = (this.ocrExtractedInvoiceNumber || '').toString().trim();
    const currentInvoiceNo = (this.form.get('invoiceNo')?.value || '').toString().trim();

    if (!extractedInvoiceNo || !currentInvoiceNo || extractedInvoiceNo === currentInvoiceNo) {
      return false;
    }

    return currentInvoiceNo !== this.acknowledgedOcrInvoiceNumberMismatch;
  }

  private openInvoiceOcrInvoiceMismatchModal() {
    this.showInvoiceOcrInvoiceMismatchModal = true;
  }

  onInvoiceNoBlur(event: FocusEvent | null) {
    void this.validateInvocieNumber(event);
    if (this.shouldShowInvoiceOcrInvoiceMismatchModal()) {
      this.openInvoiceOcrInvoiceMismatchModal();
    }
  }

  continueWithInvoiceNumberMismatch() {
    const currentInvoiceNo = (this.form.get('invoiceNo')?.value || '').toString().trim();
    this.acknowledgedOcrInvoiceNumberMismatch = currentInvoiceNo;
    this.showInvoiceOcrInvoiceMismatchModal = false;
    void this.nextStep();
  }

  undoInvoiceNumberMismatch() {
    this.showInvoiceOcrInvoiceMismatchModal = false;
    this.acknowledgedOcrInvoiceNumberMismatch = '';
    this.form.get('invoiceNo')?.setValue(this.ocrExtractedInvoiceNumber || null);
    this.form.get('invoiceNo')?.markAsTouched();
    this.form.get('invoiceNo')?.markAsDirty();
    this.form.get('invoiceNo')?.updateValueAndValidity();
  }

  private syncInvoiceOcrProductGuidance() {
    this.showInvoiceOcrProductFallbackGuidance =
      this.isInvoiceOcrEnabled && this.showConfirmExtractedInvoice && !this.products?.length;
  }

  private clearProductValidationError() {
    this.productValidationErrorKey = '';
  }

  private hasMissingProductCountryFromOcr(products: InvoiceOcrExtractedProduct[] = []): boolean {
    return products.some((product) => !(product?.country || '').toString().trim());
  }

  private applyProductValidationState(product: any): any {
    const isOcrImported = !!product?.isOcrImported;
    if (!isOcrImported) {
      return {
        ...product,
        isOcrImported: false,
        ocrNeedsReview: false,
        ocrValidationErrors: {
          hsCode: false,
          country: false
        }
      };
    }

    const matchedHsCode = this.getMatchedHsCode(product?.productHSCode);
    const matchedCountry = this.getMatchedCountryValue(product?.country);

    return {
      ...product,
      isOcrImported: true,
      country: matchedCountry ?? (product?.country || ''),
      productHSCode: matchedHsCode?.code ?? (product?.productHSCode || ''),
      productNameEn: matchedHsCode?.name ?? (product?.productNameEn || ''),
      productNameAr: matchedHsCode?.description ?? (product?.productNameAr || ''),
      ocrNeedsReview: !matchedHsCode || !matchedCountry,
      ocrValidationErrors: {
        hsCode: !matchedHsCode,
        country: !matchedCountry
      }
    };
  }

  private resolveEditedOcrProduct(existingProduct: any, submittedProduct: any): any {
    const mergedProduct = {
      ...existingProduct,
      ...submittedProduct,
      isOcrImported: !!existingProduct?.isOcrImported
    };

    const normalizedProduct = this.applyProductValidationState(mergedProduct);
    const hasSubmittedHsCode = !!(submittedProduct?.productHSCode || '').toString().trim();
    const hasSubmittedCountry = !!(submittedProduct?.country || '').toString().trim();

    if (!existingProduct?.isOcrImported) {
      return normalizedProduct;
    }

    const hsCodeError = hasSubmittedHsCode ? false : !!normalizedProduct?.ocrValidationErrors?.hsCode;
    const countryError = hasSubmittedCountry ? false : !!normalizedProduct?.ocrValidationErrors?.country;

    return {
      ...normalizedProduct,
      ocrNeedsReview: hsCodeError || countryError,
      ocrValidationErrors: {
        hsCode: hsCodeError,
        country: countryError
      }
    };
  }

  private getInvalidProductsForSubmission(): any[] {
    return (this.products || []).filter((product: any) => {
      const country = (product?.country || '').toString().trim();
      const hsCode = (product?.productHSCode || '').toString().trim();
      return !country || !hsCode || !!product?.ocrNeedsReview;
    });
  }

  private validateRequiredProductDetails(): boolean {
    if (this.step < 4 || !this.products?.length) {
      this.clearProductValidationError();
      return true;
    }

    const invalidProducts = this.getInvalidProductsForSubmission();
    if (!invalidProducts.length) {
      this.clearProductValidationError();
      return true;
    }

    this.productValidationErrorKey = 'COO.PRODUCT_VALIDATION.HS_ORIGIN_REQUIRED';
    this.form.get('products')?.markAsTouched();
    this.form.get('products')?.markAsDirty();
    //this.sharedService.toastMessage('ERROR', 'COO.PRODUCT_VALIDATION.HS_ORIGIN_REQUIRED', 'error', false);
    document.getElementById('coo-products-section')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    return false;
  }

  // This method is used to move to the next step
  async nextStep(): Promise<void> {
    const stepFieldsMap: { [key: number]: string[] } = {
      1: [],
      2: [],
      3: ['membershipId', 'gspAU', 'GSPAuthorizedPerson', 'exporter', 'exporterType', 'consignee', 'consigneeType',
        'invoiceNo', 'invoiceDate', 'invAmount',
        'directShip', 'transportMode', 'exitPoint', 'countryDest'],
      4: ['products', 'paymentMethod'],
      5: ['stampPosition','confirmExtractedInvoice']
    };
    if (this.textFields && this.optionFields) {
      this.allFields = [...this.optionFields.toArray(), ...this.textFields.toArray(), ...this.dateFields.toArray(), ...this.mobileFields.toArray()];
    }
    if (this.step == 1) {
      this.getCOOList();
    }
    if (this.step > 2) {
      this.isFromSumit = true;
    }

    if (!environment.ignoreValidators) {
      // Validate all steps up to the current step
      for (let i = 1; i <= this.step; i++) {
        const fieldsToCheck = stepFieldsMap[i] || [];
        if (Utils.handleInvalidStep(this.form, this.allFields, fieldsToCheck)) {
          const invalidControls = Utils.getInvalidControls(this.form);
          this.form.markAllAsTouched();
          Utils.focusFirstInvalidControl(this.form, this.allFields);
          console.warn('Invalid controls:', invalidControls);
          return;
        }
      }
    }
    if (this.shouldBlockInvoiceDetailsProgress()) {
      if (this.shouldShowInvoiceOcrUploadGuidance()) {
        this.sharedService.toastMessage('ERROR', 'UPLOAD_CLEAR_INVOICE_MESSAGE', 'error', false);
        this.scrollToInvoiceOcrBox();
      }
      this.focusInvoiceDetailsForCompletion();
      return;
    }
    if (this.shouldBlockConfirmExtractedInvoiceProgress()) {
      this.form.get('confirmExtractedInvoice')?.markAsTouched();
      this.form.get('confirmExtractedInvoice')?.markAsDirty();
      this.form.get('confirmExtractedInvoice')?.updateValueAndValidity();
      return;
    }
    if (this.shouldShowInvoiceOcrInvoiceMismatchModal()) {
      this.openInvoiceOcrInvoiceMismatchModal();
      return;
    }
    if (this.step >= 4 && !this.validateRequiredProductDetails()) {
      return;
    }
    const formData = this.form.getRawValue();
    if (this.step === 3 || this.step === 4) {
      if (this.srNumber == "") {
        await this.submitSRData(formData, SrActionType.DRAFT);
      }
    }
    const invalidControls = Utils.getInvalidControls(this.form);
    if (this.step >= 5) {
      if (this.form.invalid && invalidControls) {
        this.form.markAllAsTouched();
        Utils.focusFirstInvalidControl(this.form, this.allFields);
        return;
      }
      await this.submitSRData(formData, SrActionType.SUBMIT);
    }
    
    const isInvoiceValid = await this.validateInvocieNumber(null);
    if (!isInvoiceValid) {
      return;
    }


    if (this.step < 5) {
      this.step++;
    }
  }

  // This method is used to return to the previous step
  prevStep() {
    if (this.step > 0) {
      this.step--;
    }
  }

  // Displayed subset of products
  visibleProducts: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 4;
  // totalPages: number = 0;
  selectedPersonalEffecType: string = "";
  openAddProductModal() {
    this.selectedProduct = '';
    this.selectedProductMode = "add";
    this.addProductModal = true;
    this.selectedPersonalEffecType = "";
    if (this.products && this.products.length > 0 && this.isPersonalUse) {
      this.selectedPersonalEffecType = this.products[0].cooPersonalEffectType;
    }
  }

  // This method is used to handle product submit event using new added products
  onProductSubmit(newProductObj: any) {
    if (newProductObj?.replaceAll) {
      this.products = (newProductObj?.allProducts || []).map((product: any) => {
        const existingProduct = this.products.find((item: any) => item.id === product.id);
        return this.resolveEditedOcrProduct(existingProduct, product);
      }
      );
    } else {
      newProductObj?.allProducts?.forEach((newProduct: any) => {
        const index = this.products.findIndex((p: any) => p.id === newProduct.id);
        const normalizedProduct = this.resolveEditedOcrProduct(this.products[index], newProduct);
        if (index !== -1) {
          this.products[index] = { ...this.products[index], ...normalizedProduct };
        } else {
          this.products.push(normalizedProduct);
        }
      });
    }
    // Update pagination
    this.form.get("products")?.setValue(this.products.length > 0 ? "selected" : "");
    if (this.totalPages < 2) {
      this.currentPage = 1;
    }
    this.syncInvoiceOcrProductGuidance();
    this.clearProductValidationError();
    this.loadPage(this.currentPage);
    this.updateDocumentMandatory(true);
    this.makeOthersDocumentMandatory();
  }

  selectedProduct: any = "";
  selectedProductMode:string = "add";
  // This method is used to edit product using product
  editProduct(product: any, mode:string = "edit") {
    this.selectedProductMode = mode;
    this.selectedPersonalEffecType = "";
    if (this.products && this.products.length > 1 && this.isPersonalUse) {
      this.selectedPersonalEffecType = this.products[0].cooPersonalEffectType;
    }
    this.selectedProduct = product;
    this.addProductModal = true;
    this.updateDocumentMandatory();
    this.makeOthersDocumentMandatory();
  }

  // This method is used to load page using page number
  loadPage(page: number): void {
    this.currentPage = page;
    const start = (page - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.visibleProducts = this.products.slice(start, end);
  }
  // This method is used to remove product 
  removeProduct(productToRemove: any): void {
    this.products = this.products.filter((p: any) => p.id !== productToRemove.id);
    // If current page is now empty, go back one page (if not on page 1)
    const currentStartIndex = (this.currentPage - 1) * this.itemsPerPage;
    if (this.products.length <= currentStartIndex && this.currentPage > 1) {
      this.currentPage--;
    }
    this.form.get("products")?.setValue(this.products.length > 0 ? "selected" : "");
    //this.syncInvoiceOcrProductGuidance();
    if (this.products.length) {
      this.validateRequiredProductDetails();
    } else {
      this.clearProductValidationError();
    }
    // Reload the visible products for the current page
    this.loadPage(this.currentPage);
    this.updateDocumentMandatory(true);
    this.makeOthersDocumentMandatory();
  }


  // This method is used to filter products list
  get filteredProducts() {
    const term = this.form.get("searchProductText")?.value.trim().toLowerCase();
    if (!term) {
      return this.products;
    }
    return this.products.filter((p: any) =>
      (p.productHSCode?.includes(term)) ||
      (p.productNameEn?.toLowerCase().includes(term)) ||
      (p.productNameAr?.toLowerCase().includes(term)) ||
      (p.country?.toLowerCase().includes(term))
    );
  }

  // This method is used to paginated products
  get paginatedProducts() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredProducts.slice(start, start + this.pageSize);
  }

  // This method is used to total pages
  get totalPages() {
    return Math.ceil(this.filteredProducts.length / this.pageSize);
  }


  isFromSumit: boolean = false;
  formSubmitLoader: boolean = false;
  private submitSrDataInProgress: boolean = false;
  isSaved: boolean = false;
  successModal: boolean = false;
  showActions: boolean = true;
  loadingSrDetail: boolean = false;

  // This method is used to get sr detail using is copy from sr
  private getSRDetail(isCopyFromSr: boolean = false) {
    this.loadingSrDetail = true;
    const queryReq = new CooQueryRequest();

    queryReq.body.DCLoginName = this.userLoginName;
    queryReq.body.DCMethod = "QUERY"

    queryReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    let portalSr = queryReq.body.DCIncomingHierarchy.ListOfDCCOOMOBILE.MEMBER;

    portalSr.CSN = this.userCSN;
    portalSr.ListOfSERVICEREQ.SERVICEREQ["SR Number"] = isCopyFromSr ? this.copyFromSr : this.srNumber;
    portalSr.ListOfSERVICEREQ.SERVICEREQ.CSN = this.userCSN;
    portalSr.ListOfSERVICEREQ.SERVICEREQ['SR Type'] = this.srType;
    portalSr.ListOfSERVICEREQ.SERVICEREQ['SR Sub Type'] = this.srSubType;

    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.QUERY_COO,
      queryReq
    ).subscribe({
      next: (response: any) => {
        if (response["Error Code"] == null || response["Error Code"] == "" && response["Error Message"] == null || response["Error Message"] == "" && response["SiebelMessage"]?.["DC Service Request Thin"]) {
          this.loadingSrDetail = false;

          let srData = response["SiebelMessage"]["DC Service Request Thin"];
          this.userCSN = srData.CSN;
          this.loadDataBasedOnSrMember();

          this.form.patchValue(
            Object.keys(fieldMapping).reduce((acc, key) => {
              if (key == "consigneeType") {
                acc[key] = srData["DC Consignee Type eService"] ?? null;
              }
              else if (key == "invoiceNo" && isCopyFromSr && !this.isAmendmentCOO) {
                acc[key] = "";
              }
              else if (key == "requiredCOO") {
                acc[key] = srData[fieldMapping[key]] == "Y" ? "Yes" : "No";
              }
              else if (key == "attestationRequired") {
                if (isCopyFromSr || this.isAmendmentCOO && !this.srNumber) {
                  acc[key] = "";
                } else {
                  acc[key] = srData[fieldMapping[key]] == "Y" ? "Yes" : "No";
                }
              }
              else if (key == "consignee") {
                acc[key] = srData['DC Consignee Id'] && srData['DC Consignee Name'] ? srData['DC Consignee Id'] : null;
              }

              else if (key == "invoiceDate") {
                const invoiceDate = srData[fieldMapping[key]]
                  ? new Date(srData[fieldMapping[key]])
                  : "";
                acc[key] = {
                  day: invoiceDate ? invoiceDate.getDate().toString().padStart(2, '0') : null,
                  month: invoiceDate ? Number(invoiceDate.getMonth() + 1).toString().padStart(2, '0') : null,
                  year: invoiceDate ? invoiceDate.getFullYear() : null,
                }
              } else if (key == "expectedDepartureDate") {
                const departureDate = srData[fieldMapping[key]]
                  ? new Date(srData[fieldMapping[key]])
                  : "";
                acc[key] = {
                  day: departureDate ? departureDate.getDate().toString().padStart(2, '0') : null,
                  month: departureDate ? Number(departureDate.getMonth() + 1).toString().padStart(2, '0') : null,
                  year: departureDate ? departureDate.getFullYear() : null,
                }
              } else {
                acc[key] = srData[fieldMapping[key]] ?? null;
              }
              return acc;
            }, {} as any)
          );
          this.currentSrStatus = srData["Status"] ?? "";
          this.docAiScanFlag = srData['DC Doc AI Scan Flag'] === 'Y' ? 'Y' : 'N';
          this.initialInvoiceNoForValidation = (this.form.get('invoiceNo')?.value || '').toString().trim();
          this.exporterMemberNumber = srData['DC Exporter Number'];
          Utils.disableFieldsBasedOnSubService(
            this.servicePath,
            this.form,
            srData['DC Parent COO Print Dte'] ? srData['DC Parent COO Print Dte'] : srData['DC COO Print Date']
          );
          if (this.isPersonalUse) {
            this.form.get('exporter')?.setValue(srData["DC Exporter Name (Eng)"]);
          }

          let object = {
            id: srData["DC Consignee Id"] ?? 0,
            name: srData["DC Consignee Name"],
            country: srData["DC Country"] ?? "",
            city: srData["DC City"],
            countryCode: srData["DC Consignee Phone"] ? Utils.parseMobile(srData["DC Consignee Phone"], 'cc') : "",
            phone: srData["DC Consignee Phone"] ? Utils.parseMobile(srData["DC Consignee Phone"], 'number') : "",
            address: srData["DC Address 1"],
            poBox: srData["DC Consignee PO Box Number"],
            fax: srData["DC Consignee Fax"]
          }
          if (srData["DC Country"]) {
            this.getDischagePort(srData["DC Country"]);
          }

          // for mode change
          if (srData["DC Transport By"]) {
            //For safe check if old application with this value
            if (srData["Status"] == SrStatus.Draft && (srData["DC Transport By"] === 'By Air/Sea' || srData["DC Transport By"] === "جواً / بحراً")) {
              this.form.get('transportMode')?.setValue(null);
            }

            let selectionMode = this.motLovList.find((m: any) => m.Value == srData["DC Transport By"] || m.Name == srData["DC Transport By"])
            if (selectionMode) {
              let motOptionObj = {
                "lovType": "",
                "selectedLov": selectionMode
              }
              this.onTransportModeChange(motOptionObj);
            }
          }

          if (srData["DC Consignee Name"] && srData["DC Consignee Id"]) {
            const cooAssignee = this.createConsObject(object, this.selectedConsigneesLists.length, srData["DC Consignee Id"]);
            this.selectedConsigneesLists = [...this.selectedConsigneesLists, cooAssignee];
          }

          const resProducts = Utils.checkIsArray(srData?.["DC Internal Product Clone"]);
          const mappedProducts: any = resProducts?.map((p: any) => ({
            id: Utils.generateUniqueId(), //p['DC Product Id'],
            mode: "auto",
            search: "loaded",
            country: p["DC Country of Origin"] || "",
            unit: p["DC Unit of Measure"] || "",
            quantity: String(p["DC Quantity"] ?? ""),
            bulkFile: null,
            productHSCode: p["DC HS Code"] ?? null,
            productNameEn: p["DC Product English Name"] || "",
            productNameAr: p["DC Product Arabic Name"] || "",
            unitPrice: String(p["DC Unit Price"] ?? ""),
            category: p["DC Category Desc"] ?? p["DC Category Des LIC"],
            weight: String(p["DC Weight"] ?? ""),
            cooPersonalEffectType: p["DC Export Type"] || "",
            cooVehicleCategory: p["DC Vehicle Category"] || "",
            cooVehicleChassisNumber: p["DC Vehicle Chassis Number"] || "",
            cooVehicleColor: p["DC Vehicle Color"] || "",
            cooVehicleEngineNumber: p["DC Vehicle Engine Number"] || "",
            cooVehicleMake: p["DC Vehicle Make"] || "",
            cooVehicleModel: p["DC Vehicle Model"] || "",
            cooVehicleSubMake: p["DC Vehicle Sub Make"] || "",
            processingType: p["DC Process Type"] || "",
            processingCountry: p["DC Processing Country"] || ""
          }));
          if (mappedProducts) {
            this.products = [...this.products, ...mappedProducts];
          }

          // Update pagination
          this.form.get("products")?.setValue(this.products.length > 0 ? "selected" : "");
          this.loadPage(this.currentPage);
          this.updateDocumentMandatory();

          let isDirectShipment = srData['DC Direct Shipment'] && srData['DC Direct Shipment'] == FieldValue.YES || srData['DC Direct Shipment'] == FieldValue.YES_AR ? true : false;
          this.setExpointValue(isDirectShipment);

          //get selected signatory
          // if (srData["Status"] == SrStatus.Draft || srData["Status"] == SrStatus.AwaitingClarification || srData["Status"] == SrStatus.Open && !this.singatoryList) {
          //   this.getMemberSignatory();
          // }
          // else {
          //   this.singatoryList = [];
          //   let obj = {
          //     "DC Related Party Name English": srData["DC Print Name English"],
          //     "DC Related Party Name Arabic": srData["DC Print Name Arabic"]
          //   }
          //   this.singatoryList.push(obj);
          // }
          if (this.form.get('attestationRequired')?.value == 'Yes') {
            this.makeSignatoryRequired('Yes');
          }

          if (!isCopyFromSr) {
            if (this.sharedService.enableNotesOption(srData["Status"])) {
              this.srInprgoressAwating = true;
              this.showNotes = true;
            }
            if (srData['DC Transport By']) {
              this.step = 5;
            } else {
              this.step = 4;
            }
            if (srData["Status"] != SrStatus.Draft && srData["Status"] != SrStatus.AwaitingClarification && srData["Status"] != SrStatus.Open) {
              this.showActions = false;
              this.form.disable(); // disables all fields in the form
              this.form.get('searchProductText')?.enable();
            }
          } else {
            this.step = 4;
          }
        } else {
          this.technicalErrorMsg = true;
        }
      },
      error: () => {
        this.loadingSrDetail = false
      }
    })
  }

  // This method is used to save and close
  async saveAndClose(isPrintCertificate: boolean = false): Promise<void> {
    if (!this.validateRequiredProductDetails()) {
      return;
    }
    const invalidControls = Utils.getInvalidControls(this.form);
    console.warn('Invalid controls:', invalidControls);
    const formFieldData = this.form.getRawValue();
    this.updateDocumentMandatory(true);
    if (isPrintCertificate == true && (this.formProgress < 100 || this.form.invalid)) {
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
      return;
    }
    await this.submitSRData(formFieldData, SrActionType.SAVE, isPrintCertificate);
  }
  errorMsg: string = "";
  restrictedWordErrorMsg: string = "";
  technicalErrorMsg: boolean = false;
  // This method is used to submit sr data using form data and action type
  private async submitSRData(formData: any, actionType: string, isPrintCertificate: boolean = false): Promise<void> {
    if (this.submitSrDataInProgress) {
      return;
    }

    this.errorMsg = "";
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;

    if (Utils.hasMaxLengthError(this.form)) {
      this.form.markAllAsTouched();
      return;
    }

    if (isActionSubmit && !this.validateRequiredProductDetails()) {
      return;
    }

    const isInvoiceValid = await this.validateInvocieNumber(null);
    if (!isInvoiceValid) {
      return;
    }
    const defaultShowActions = this.showActions;
    const restoreFormState = () => {
      this.showActions = defaultShowActions;
    }

    if (isActionSubmit && this.shouldShowCopyInvoiceOcrSubmitGuidance()) {
      this.sharedService.toastMessage('ERROR', 'UPLOAD_CLEAR_INVOICE_MESSAGE', 'error', false);
      this.scrollToInvoiceOcrBox();
      this.form.get('invoiceNo')?.markAsTouched();
      this.form.get('invoiceNo')?.markAsDirty();
      this.form.get('invoiceNo')?.updateValueAndValidity();
      return;
    }

    if (isActionSubmit && this.form.invalid || this.noAdvancePaymentBalance) {
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
      return;
    }

    // Always sync mandatory state before validation
    this.makeOthersDocumentMandatory();

    // Product COO UAE specific check for trade license in 'Others' documents
    if (isActionSubmit && this.requiresOthersDocumentForUaeOrigin()) {
      // Ensure UI marks it as mandatory
      this.makeOthersDocumentMandatory();
      if (this.isOthersDocumentMissing()) {
        this.errorMsg = "Please upload trade license copy along with purchase invoice in 'Others' document.";
        this.sharedService.toastMessage('ERROR', "UPLOAD_TRADE_LICENSE", 'error', true);
        return;
      }
    }
    //FOR GSP Certificate if license is Indstrial or Trading
    if (isActionSubmit && this.isGspCertificate && this.requiresOthersDocumentForGspLicense()) {
      const licenseType = this.getNormalizedLicenseType();
      if (this.isOthersDocumentMissing() && this.isTradingLicenseType(licenseType)) {
        this.errorMsg = "Please upload industrial license copy along with purchase invoice in 'Others' document.";
        this.sharedService.toastMessage('ERROR', "UPLOAD_INDUSTRIAL_LICENSE", 'error', true);
        return;
      }
      if (this.isOthersDocumentMissing() && this.isIndustrialLicenseType(licenseType)) {
        this.errorMsg = "Please upload an purchase invoice in 'Others' document.";
        this.sharedService.toastMessage('ERROR', "UPLOAD_PURCHASE_INVOICE", 'error', true);
        return;
      }
    }
    if (isActionSubmit && this.checkRequiredDocuments()) {
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error');
      return;
    }

    if (isActionSubmit) {
      if(!this.mainFromSectionDocs || this.mainFromSectionDocs?.length < 1) {    
        this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error');
        return;
      }
      // COO Invoice validation for non-personal use
      if(!this.isPersonalUse){
        const isCooInvoiceExist = this.srFolder?.documents?.find((doc) => doc.documentType == "COO_Invoice");
        if(!isCooInvoiceExist){
          this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
          return;
        }
      }
      const hasRestrictedWord = this.validateAdditionalDetailsField(
        formData?.additionalDetails
      );
      if (hasRestrictedWord || this.loadingDoc) {
        return;
      }
      // signatory selection validation
      if (formData.attestationRequired == 'Yes' && !formData?.signatory) {
        return;
      }
    }


    let cooReq = new CooPayload();
    cooReq.body.DCLoginName = this.userLoginName;
    cooReq.body.DCLanguage = this.lang == 'ar' ? "ARA" : "ENU";
    cooReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    cooReq.body.DCMethod = isActionSubmit ? "SUBMIT" : "CREATE";
    cooReq.body.DCIncomingHierarchy.ListOfDCCOOMOBILE.MEMBER.CSN = this.userCSN;
    let portalSr = cooReq.body.DCIncomingHierarchy.ListOfDCCOOMOBILE.MEMBER.ListOfSERVICEREQ.SERVICEREQ;

    let invoiceDate = formData.invoiceDate.day ?
      `${formData.invoiceDate.month}/${formData.invoiceDate.day}/${formData.invoiceDate.year}` : '';
    let expectedDepartureDate = formData.expectedDepartureDate?.day ?
      `${formData.expectedDepartureDate.month}/${formData.expectedDepartureDate.day}/${formData.expectedDepartureDate.year}` : '';


    let consignee = this.selectedConsigneesLists.length > 0 ?
      this.selectedConsigneesLists[this.selectedConsigneesLists.length - 1].formFields : "";

    portalSr["SR Number"] = this.srNumber;
    portalSr["CSN"] = this.userCSN;
    portalSr['SR Type'] = this.srType;
    portalSr['SR Sub Type'] = this.srSubType;
    portalSr['Comments'] = "";
    portalSr['Currency'] = formData.invCurrency;
    portalSr['DC Additional Detail'] = formData.additionalDetails ? formData.additionalDetails.trim() : "";
    portalSr['DC Doc AI Scan Flag'] = this.docAiScanFlag;
    portalSr['DC Address 1'] = consignee ? consignee.address ?? "" : "";
    portalSr['DC Address 2'] = ""
    portalSr['DC Address 3'] = "";
    portalSr['DC COO Number'] = this.isAmendmentCOO ? (formData.cooNumber ?? "") : "";
    portalSr['DC City'] = consignee && consignee?.city ? (consignee.city.trim()) : "";
    portalSr['DC Consignee Id'] = consignee ? (formData.consignee != "Added" ? formData.consignee : "") : "";
    portalSr['DC Consignee PO Box Number'] = consignee ? consignee.poBox ?? "" : "";
    portalSr['DC Consignee Fax'] = consignee ? consignee.fax ?? "" : "";
    portalSr['DC Consignee Name'] = consignee ? consignee.name ?? "" : "";
    portalSr['DC Consignee Phone'] = consignee?.phone && consignee.countryCode ? `${consignee.countryCode}${consignee.phone}` : "";
    portalSr['DC Consignee Type'] = formData.consigneeType ?? formData.consigneeType;
    portalSr['DC Consignee Type eService'] = formData.consigneeType ?? "";
    portalSr['DC Country'] = consignee.country ?? "";
    portalSr['DC Direct Shipment'] = formData.directShip;
    portalSr['DC Shipping From'] = formData.shippingFrom;
    portalSr['DC Exit Point'] = formData.exitPoint;
    portalSr['DC Expected Departure Date'] = expectedDepartureDate;
    portalSr['DC Exporter Id'] = this.isPersonalUse ? this.exporters[0].Value : (formData.exporter ? formData.exporter : "");
    portalSr['DC Exporter Fax'] = "";
    portalSr['DC Exporter Name (Ara)'] = "";
    portalSr['DC Exporter Name (Eng)'] = this.isPersonalUse ? formData.exporter : "";
    portalSr['DC Exporter Number'] = this.exporterMemberNumber ?? "";
    portalSr['DC Exporter PO Box Number'] = "";
    portalSr['DC Exporter Phone'] = "";
    portalSr['DC Exporter Type'] = formData.exporterType;
    portalSr['DC Final Destination'] = formData.countryDest; //should be same as selected consigne Country
    portalSr['DC Invoice Amount'] = formData.invAmount;
    portalSr['DC Invoice Date'] = formData.invoiceDate ? invoiceDate : "";
    portalSr['DC Invoice Number'] = formData.invoiceNo ? formData.invoiceNo.trim() : "";
    portalSr['DC Language'] = this.lang == 'ar' ? 'Arabic' : "English";//lang
    portalSr['DC No of COO Sets'] = "1";
    portalSr['DC No of Copies'] = "1";
    portalSr['DC No of Invoice Pages'] = "1";
    portalSr['DC No of Invoice Sets'] = "1";
    portalSr['DC No of Pack List Pages'] = "1";
    portalSr['DC No of Pack List Sets'] = "1";
    portalSr['DC Payment Method'] = formData.paymentMethod ? formData.paymentMethod : '';
    //this.lang == 'ar' ? FieldValue.PAYMENT_METHOD_ONLINE_AR : FieldValue.PAYMENT_METHOD_ONLINE_EN;
    portalSr['DC Port of Discharge'] = formData.portOfDischarge;
    portalSr['DC Print COO Product Flg'] = this.isPersonalUse ? 'Y' : (formData.requiredCOO == 'Yes' ? 'Y' : 'N'); //Y/N
    portalSr['DC Transport By'] = formData.transportMode;
    portalSr['DC GSP Authorized Person'] = formData.GSPAuthorizedPerson ?? "";
    portalSr['DC Channel'] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    portalSr['DC Require Attestation Flag'] = formData.attestationRequired == 'Yes' ? 'Y' : 'N';

    let signatory: any = this.singatoryList?.find((s: any) => s["DC Related Party Name English"] == formData?.signatory);
    portalSr['DC Print Name English'] = signatory && formData.attestationRequired == 'Yes' ? signatory["DC Related Party Name English"] : "";
    portalSr['DC Print Name Arabic'] = signatory && formData.attestationRequired == 'Yes' ? signatory["DC Related Party Name Arabic"] : "";

    const hasInvalidProductsForDraft = isActionDraft && this.getInvalidProductsForSubmission().length > 0;
    if (this.products && !hasInvalidProductsForDraft) {
      const productsPayload = this.mapProductsToPayload(this.products);
      portalSr.ListOfPRODUCT.PRODUCT = productsPayload;
    }
    this.formSubmitLoader = isActionDraft ? false : true;
    this.technicalErrorMsg = false;
    if (isActionDraft && this.srNumber == "") {
      this.loadingDoc = true;
    }
    this.submitSrDataInProgress = true;
    if (isActionSubmit) {
      this.showActions = false;
    }
    this.api.postWithoutRetry(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.CREATE_COO,
      cooReq
    ).subscribe({
      next: (response: any) => {
        if (response['Error Code'] == null && response["DCSRNumber"] && response["Error Message"] == null || response["Error Message"] == "") {
          this.isSaved = true;
          restoreFormState();
          if (isActionSave || isActionDraft) {
            if (isPrintCertificate) {
              //call for preview certificate
              this.previewCertificate();
            } else {
              if (isActionDraft && this.srNumber == "") {
                this.srNumber = response["DCSRNumber"];
                sessionStorage.setItem("srNumber", response["DCSRNumber"]);
              } else {
                this.srNumber = response["DCSRNumber"];
                if (isActionSave) {
                  this.successModal = true;
                }
              }
              this.formSubmitLoader = false;
              this.openFolder();
            }
          } else {
            this.srNumber = response["DCSRNumber"];
            this.removePreviousDocuments();
            //set sr detail for success page to get ioname
            let lang: any = this.sharedService.getCurrentLang();

            const { service, serviceAr } = Utils.getServiceLabels(this.srSubType, lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              mainService: this.srType,
              service: this.srSubType,
              IOName: SrIOName.COO_CREATE,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step,
              memberCSN: this.userCSN
            }
            this.sharedService.setSrResponse(srDetailObj);

            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
            this.formSubmitLoader = false;
          }
          this.submitSrDataInProgress = false;
        } else {
          // this.errorMsg = response["Error Message"];
          restoreFormState();
          this.formSubmitLoader = false;
          this.technicalErrorMsg = true;
          this.submitSrDataInProgress = false;
        }
      },
      error: (e) => {
        restoreFormState();
        this.formSubmitLoader = false;
        this.technicalErrorMsg = true;
        this.submitSrDataInProgress = false;
      }
    })
  }
  // This method is used to map products to payload using products
  mapProductsToPayload(products: any[]): any[] {
    return products.map((p, index) => ({
        "DC Country of Origin": p.country || "",
        "DC HS Code": p.productHSCode || "",
        "DC Process Type": p.processingType || "",
        "DC Processing Country": p.processingCountry || "",
        "DC Product Arabic Name": p.productNameAr || "",
        "DC Product English Name": p.productNameEn || "",
        "DC Product Id": p.id || "",
        "DC Seq Of Item": String(index + 1),
        "DC Quantity": p.quantity || "",
        "DC Unit Price": p.unitPrice || "",
        "DC Unit of Measure": p.unit || "",
        "DC Unit of Weight": "",
        "DC Weight": p.weight || "",
        "DC Export Type": p.cooPersonalEffectType || "",
        "DC Vehicle Category": p.cooVehicleCategory || "",
        "DC Vehicle Chassis Number": p.cooVehicleChassisNumber || "",
        "DC Vehicle Color": p.cooVehicleColor || "",
        "DC Vehicle Engine Number": p.cooVehicleEngineNumber || "",
        "DC Vehicle Make": p.cooVehicleMake || "",
        "DC Vehicle Model": p.cooVehicleModel || "",
        "DC Vehicle Sub Make": p.cooVehicleSubMake || "",
    }));
  }
  // This method is used to calculate form progress
  get formProgress() {
    if (this.form.disabled) {
      return 100;
    }
    if (!this.form.invalid) {
      if (!this.checkRequiredDocuments()) {
        return 100;
      }
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps)
  }
  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }
  // This method is used to open terms condition
  openTermsCondition() {
    let url = `${RoutesPath.SERVICE}/${RoutesPath.ATA.TERMS}`
    this.router.navigate([url]);
  }
  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {

  }

  shouldShowDocumentUploadInput(documentType: { nameEn?: string } | string): boolean {
    const resolvedDocumentType = typeof documentType === 'string' ? documentType : documentType?.nameEn || '';
    if (resolvedDocumentType !== CertificateOfOriginComponent.OCR_AUTO_UPLOAD_DOCUMENT_TYPE) {
      return true;
    }

    return this.showActions;
  }

  shouldShowDocumentActions(documentType: { nameEn?: string } | string): boolean {
    const resolvedDocumentType = typeof documentType === 'string' ? documentType : documentType?.nameEn || '';
    if (resolvedDocumentType !== CertificateOfOriginComponent.OCR_AUTO_UPLOAD_DOCUMENT_TYPE) {
      return this.showActions;
    }

    return this.showActions;
  }

  private hasUploadedDocumentType(documentType: string): boolean {
    return !!this.srFolder?.documents?.some(
      (doc: any) => (doc?.documentType || '').toLowerCase() === documentType.toLowerCase()
    );
  }

  private getUploadedDocumentsByType(documentType: string): any[] {
    return (this.srFolder?.documents || []).filter(
      (doc: any) => (doc?.documentType || '').toLowerCase() === documentType.toLowerCase()
    );
  }

  // Function for get all hs codes for validate on file upload
  totalHsRecords: number = 0;
  hsCodeRowNum: number = 0;
  masterHSCodeList: any = [];
  // This method is used to get master hs code
  async getMasterHsCode(): Promise<[]> {
    let pageSize: any = 7000;
    this.hsCodeRowNum = 0;
    this.masterHSCodeList = [];

    const product = this.hsCodeRequest.body.IncomingHierarchy.ListOfDCHSCODELIST.PRODUCT;
    product.ProductCode = '';
    product.Description = '';

    do {
      this.hsCodeRequest.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();
      this.hsCodeRequest.body.StartRowNum = this.hsCodeRowNum;
      this.hsCodeRequest.body.PageSize = pageSize;
      this.hsCodeRequest.body.NewQuery = this.hsCodeRowNum === 0 ? 'true' : 'false';
      this.hsCodeRequest.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';

      const response: any = await lastValueFrom(
        this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_HS_CODE, this.hsCodeRequest)
      );

      if (response?.SiebelMessage && response?.SiebelMessage['PRODUCT']) {
        this.totalHsRecords = response.TotalRecords;
        let hsProducts = Utils.checkIsArray(response?.SiebelMessage['PRODUCT']);

        const mappedProducts = hsProducts.map(
          (hs, index) => ({
            id: this.hsCodeRowNum + index + 1,
            code: hs.ProductCode,
            name: hs.Description,
            description: hs.ProductNameARA,
          })
        );
        this.masterHSCodeList = [...this.masterHSCodeList, ...mappedProducts];
      }

      this.hsCodeRowNum += pageSize;
    } while (this.hsCodeRowNum < this.totalHsRecords);
    return this.masterHSCodeList;
  }
  // This method is used to remove previous documents
  removePreviousDocuments() {
    const documentIds = this.srFolder?.documents?.filter(doc => !this.srFolder?.allowedDocumentTypes.find(ad => ad.nameEn === doc.documentType))
      .map(doc => doc.documentId);
    if (documentIds && documentIds.length > 0) {
      let data = {
        "documentServiceType": DocumentServiceType.COO,
        "mot": this.selectedModeOfTransfer,
        "svsSubject": "",
        "folderId": this.srFolder.folderId,
        "folderParentId": this.srFolder.folderParentId,
        "folderParentType": this.srFolder.folderParentType,
        "documentId": documentIds
      }
      this.sharedService.deleteBulkDocument(data);
    }
  }
  // This method is used to open add consignee modal
  openAddConsigneeModal() {
    this.form.get('consignee')?.setValue(null);
    this.selectedConsigneesLists = [];
    this.selectedConsignee = "";
    this.openConsigneeModal = true;
  }

  //This method is used to download the personal effect type template
  downloadTemplateFile(personalEffectType: string) {
    let filePath = '';

    if (
      personalEffectType === FieldValue.USED_PRODUCTS ||
      personalEffectType === FieldValue.USED_PRODUCTS_AR
    ) {
      filePath = DocumentName.COO_USED_PERSONAL_EFFECTS_BOUGHT_FROM;
    }

    if (
      personalEffectType === FieldValue.VEHICLES ||
      personalEffectType === FieldValue.VEHICLES_AR
    ) {
      filePath = DocumentName.COO_USED_VEHICLE_BOUGHT_FROM;
    }

    if (
      personalEffectType === FieldValue.ANIMALS ||
      personalEffectType === FieldValue.ANIMALS_AR
    ) {
      filePath = DocumentName.COO_ANIMAL_EXPORT_FORM;
    }

    if (!filePath) {
      return;
    }
    const link = document.createElement('a');
    link.href = filePath;
    link.target = "_blank";
    link.click();
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    this.additionalDetailsValueChangesSub?.unsubscribe();
    sessionStorage.removeItem("srNumber");
  }
  // This method is used to handle payment method change event using option
  noAdvancePaymentBalance: boolean = false;
  onPaymentMethodChange(value: any) {
    this.noAdvancePaymentBalance = false;
    const selectedValue = value;
    if (selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES || selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR) {
      this.noAdvancePaymentBalance = !this.sharedService.hasSufficientAdvanceForServicesBalance();
    } else {
      this.noAdvancePaymentBalance = false;
    }
  }

  //Method for check the restricted words from lov
  onAdditionalDetailsBlur() {
    const value = this.form.get('additionalDetails')?.value ?? null;
    this.validateAdditionalDetailsField(value);
  }

  private validateAdditionalDetailsField(value: string | null): boolean {
    const control = this.form.get('additionalDetails');
    const isRestrictedWord = this.findRestrictedWordInAdditionalDetails(value);

    this.restrictedWordErrorMsg = isRestrictedWord ? isRestrictedWord : '';
    if (control) {
      control.markAsTouched();
      control.markAsDirty();
    }
    return !!isRestrictedWord;
  }
  // This method is used find/validate the restricted words
  private findRestrictedWordInAdditionalDetails(additionalDetails: any): string | null {
    if (!additionalDetails || !this.restrictedWordsList?.length) {
      return null;
    }
    const normalizedDetails = `${additionalDetails}`.toLowerCase();
    for (const restrictedWord of this.restrictedWordsList) {
      const restrictedValue = (restrictedWord?.Value ?? restrictedWord?.Name ?? '').toString().trim();
      if (!restrictedValue) {
        continue;
      }
      const regex = new RegExp(`\\b${this.escapeRegExp(restrictedValue.toLowerCase())}\\b`, 'i');
      if (regex.test(normalizedDetails)) {
        return restrictedValue;
      }
    }
    return null;
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  // This method is used to get restricted words and mode of transports

  private getAddtionRestrictedWords(isMot: boolean = false) {
    let request = {
      body: {
        ProcessName: "DC Get List Of Values WF",
        Type: isMot ? LookupKey.COO_DC_TRASNPORT : LookupKey.DC_RESTRICT_ADDN_COO_WORDS,
        "LanguageCode": this.sharedService.getCurrentLang() == "ar" ? 'ARA' : "ENU",
        ParentValue: ''
      }
    }
    this.api
      .post(ApiRoot.DCCICPIntegration, LookupKey.LOOKUP_URL, request)
      .subscribe({
        next: (result: any) => {
          if (result.SiebelMessage?.['List Of Values'] && result["Error Message"] == null || result["Error Message"] == "") {
            let lovList = Utils.checkIsArray(result.SiebelMessage['List Of Values']);

            //Custom check for filter the By Air/Sea from list
            if (isMot && lovList) {
              this.motLovList = lovList.filter(
                (item: any) => item.Name !== "By Air/Sea"
              );

              let transportModeValue = this.form.get("transportMode")?.value;
              if (transportModeValue) {
                let selectionMode = this.motLovList.find((m: any) => m.Value == transportModeValue || m.Name == transportModeValue)
                if (selectionMode) {
                  let motOptionObj = {
                    "lovType": "",
                    "selectedLov": selectionMode
                  }
                  this.onTransportModeChange(motOptionObj);
                }
              }
            }
            //END

            this.restrictedWordsList = lovList;
          }
        }
      })
  }

  // This method is used to preview certificate
  previewCertificate() {
    if (!this.srNumber) {
      return;
    }
    let request = {
      "body": {
        "ProcessName": "DC Generate Preview API Call WF",
        "SRNumber": this.srNumber
      }
    }
    this.formSubmitLoader = true;
    this.api
      .post(ApiRoot.DCCICPIntegration, ApiEndPoints.PRINT_PREVIEW, request)
      .subscribe({
        next: (response: any) => {
          this.formSubmitLoader = false;
          if (response["Error Message"] == null && response["Error Message"] == null) {
            const previewURL = response['PreviewURL'];
            if (previewURL) {
              //const updatedUrl = previewURL.replace(/is_download_required=\d+/, 'is_download_required=2');
              this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(previewURL);
              this.showPreviewModal = true;
            } else {
              this.sharedService.toastMessage('ERROR', 'TECHNICAL_ERROR', 'error', true);
            }
          } else {
            this.technicalErrorMsg = true;
          }
        }, error: () => {
          this.formSubmitLoader = false;
          this.technicalErrorMsg = true;
        }
      })
  }

  // This method is used to close preview modal
  closePreviewModal() {
    this.showPreviewModal = false;
    this.previewUrl = "undefined";
  }

  // UAE ORIGIN VALIDATION
  private requiresOthersDocumentForUaeOrigin(): boolean {
    const licenseType = this.getNormalizedLicenseType();
    if (this.isIndustrialLicenseType(licenseType) || !this.hasUaeOriginProduct()) return false;

    const docs = this.mainFromSectionDocs || [];

    const othersDoc: any = docs.find(doc => {
      const name = (doc.nameEn || '').trim().toLowerCase();
      return name === 'other' || name === 'others' || name.includes('other');
    });
    // Return TRUE only if "others" document exists AND not uploaded
    return !!othersDoc && !othersDoc.uploaded;
  }

  private requiresOthersDocumentForGspLicense(): boolean {
    if (!this.isGspCertificate) {
      return false;
    }
    const licenseType = this.getNormalizedLicenseType();
    if (!licenseType) {
      return false;
    }
    return this.isIndustrialLicenseType(licenseType) || this.isTradingLicenseType(licenseType);
  }

  private getNormalizedLicenseType(): string {
    return (this.sharedService.getPrimaryAccount()?.['DC License Type'] ?? '')
      .toString()
      .trim()
      .toLowerCase();
  }

  private isIndustrialLicenseType(licenseType: string): boolean {
    if (!licenseType) {
      return false;
    }
    const industrialLicenseTypes = [
      FieldValue.INDUSTRIAL_LICENSE,
      FieldValue.INDUSTRIAL_LICENSE_AR,
      FieldValue.INDUSTRIAL,
      FieldValue.INDUSTRIAL_AR
    ].map(value => value.toLowerCase());
    return industrialLicenseTypes.includes((licenseType).toLowerCase());
  }

  private isTradingLicenseType(licenseType: string): boolean {
    if (!licenseType) {
      return false;
    }
    const tradingLicenseTypes = [
      FieldValue.TRADER_LICENSE,
      FieldValue.TRADER_LICENSE_AR,
      FieldValue.TRADING,
      FieldValue.TRADING_AR,
      FieldValue.TRADING_LICENSE,
      FieldValue.TRADING_LICENSE_AR
    ].map(value => value.toLowerCase());

    return tradingLicenseTypes.includes((licenseType).toLowerCase());
  }

  private isOthersDocumentMissing(): boolean {
    const docs = this.mainFromSectionDocs || [];
    const othersDoc: any = docs.find(doc => {
      const name = (doc.nameEn || '').trim().toLowerCase();
      return name === 'other' || name === 'others' || name.includes('other');
    });

    let hasMissing = false;
    if (othersDoc) {
      const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
        ? this.fileComponents.toArray()
        : [];

      // ViewChildren not ready or not fully rendered yet – defer document checks
      if (fileCmps.length < this.mainFromSectionDocs.length) {
        return false;
      }


      for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
        const name = (this.mainFromSectionDocs[index].nameEn || '').trim().toLowerCase();
        if (name === 'other' || name === 'others' || name.includes('other')) {
          const doc = this.mainFromSectionDocs[index];
          const cmp = fileCmps[index];
          // Safety guard; should not happen due to length check above
          if (!cmp) continue;

          if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
            hasMissing = true;
          }
        }
      }
    }
    return hasMissing;
  }

  makeOthersDocumentMandatory() {
    const shouldRequireOthers = this.isGspCertificate
      ? this.requiresOthersDocumentForGspLicense()
      : this.requiresOthersDocumentForUaeOrigin();
    const markDirectShip = (doc: AllowedDocumentType) => {
      const withOriginal = this.withOriginalMandatory(doc);
      if (doc.nameEn === "Others" || doc.nameEn === "others") {
        return {
          ...withOriginal,
          mandatory: shouldRequireOthers ? true : false
        };
      }
      return withOriginal;
    };

    this.mainFromSectionDocs = (this.mainFromSectionDocs || []).map(markDirectShip);
    if (this.srFolder?.allowedDocumentTypes?.length) {
      this.srFolder.allowedDocumentTypes = this.srFolder.allowedDocumentTypes.map(markDirectShip);
    }
  }

  removeAllProducts() {
    this.products = [];
    this.form.get("products")?.setValue("");
    //this.syncInvoiceOcrProductGuidance();
    this.clearProductValidationError();
    this.loadPage(this.currentPage);
  }

  checkInvoiceAmount(event: any) {
    if (!event) {
      return;
    }
    this.validateAmount();
  }
  // This is method is use to calculate invoice amount and show alert if larger 99 million
  validateAmount() {
    let invoiceAmout = this.form.get("invAmount")?.value;
    let invCurrency = this.form.get("invCurrency")?.value;
    if (invoiceAmout && invCurrency) {
      let selecctedCurrency = this.currencyList.find((c: any) => c['Currency Code'] == invCurrency)['Exchange Rate'];
      let exchangeRate = selecctedCurrency && selecctedCurrency[0]["Exchange Rate"];
      const numericValue = Number(invoiceAmout);
      if (!isNaN(numericValue)) {
        let calculatedAmount = exchangeRate ? numericValue * exchangeRate : numericValue;
        if (calculatedAmount > 99000000) { //99 million
          this.sharedService.toastMessage('ERROR', 'INVOICE_AMOUNT_MESSAGE', 'error', true);
        }
      }
    }
  }
  singatoryList: any = [];
  // This method is used to get signatory gov entity using csn
  getMemberSignatory() {
    if (!this.isAmendmentCOO && !this.isIssueCOO) {
      return;
    }
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get List of Signatory Mob App WF",
        "IncomingHierarchy": {
          "MessageId": Utils.generateUniqueId(),
          "IntObjectName": "DCGetSignatoryIO",
          "MessageType": "Integration Object",
          "IntObjectFormat": "Siebel Hierarchical",
          "ListOfDCGetSignatoryIO": {
            "Account": {
              "CSN": this.userCSN
            }
          }
        },
        "SR Sub Type": ServiceName.COO
      }
    }
    this.api.post<any, any>(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.AUTHENTICATE_CERTIFICATE, // ApiEndPoints.VERIFY_SIGNATURE : ApiEndPoints.AUTHENTICATE_CERTIFICATE,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response?.SiebelMessage && response['Error Code'] == null) {
          let account = Utils.checkIsArray(response?.SiebelMessage['Account']);
          this.singatoryList = account[0]['Party Relationship To'];
        }
      },
      error: () => {
        this.singatoryList = [];
      }
    })
  }
  makeSignatoryRequired(value: any) {
    this.toggleRequired(value && value == 'Yes', ['signatory']);
  }
  applyForManageSignatories() {
    this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.MEMBERSHIP.MANAGE_SIGNATORIES}`]);
  }

  // This method is used to handle the invoice ocr extracted result and map the values to form fields
  async onInvoiceOcrExtracted(mockResult: InvoiceOcrExtractionResult) {
    this.OCRProductHSCode = [];
    this.docAiScanFlag = 'Y';
    this.ocrExtractedInvoiceNumber = (mockResult.invoiceNo || '').toString().trim();
    this.acknowledgedOcrInvoiceNumberMismatch = '';
    this.showInvoiceOcrInvoiceMismatchModal = false;
    this.clearInvoiceOcrDateOutOfRangeError();
    const matchedCurrency = this.getMatchedLovValue(mockResult.invCurrency, this.currencyList);
    const matchedTransportMode = this.getMatchedLovValue(mockResult.transportMode, this.motLovList);
    const matchedExitPoint = this.getMatchedControlLovValue('exitPoint', mockResult.exitPoint);
    const matchedShippingFrom = this.getMatchedCountryValue(mockResult.shippingFrom);
    const matchedPortOfDischarge = this.getMatchedLovValue(mockResult.portOfDischarge, this.dischargePorts);
    const matchedDestinationCountry = this.getMatchedCountryValue(mockResult.destinationCountry);
    if (mockResult?.products) {
      // this.step = 5;
    }
    this.form.patchValue({
      invoiceNo: mockResult.invoiceNo || null,
      invoiceDate: mockResult.invoiceDate || { day: null, month: null, year: null },
      invCurrency: matchedCurrency ?? null,
      invAmount: mockResult.invAmount || null,
      transportMode: matchedTransportMode ?? null,
      exitPoint: matchedExitPoint ?? null,
      shippingFrom: matchedShippingFrom ?? null,
      portOfDischarge: matchedPortOfDischarge ?? null,
      countryDest: matchedDestinationCountry ?? null
    });

    let selectionMode = this.motLovList.find((m: any) => m.Value == matchedTransportMode || m.Name == matchedTransportMode)
    if (selectionMode) {
      let motOptionObj = {
        "lovType": "",
        "selectedLov": selectionMode
      }
      this.onTransportModeChange(motOptionObj);
    }

    this.applyInvoiceOcrMissingState({
      invoiceNo: !mockResult.invoiceNo,
      invoiceDate: !mockResult.invoiceDateOutOfRange && (
        !mockResult.invoiceDate?.day
        || !mockResult.invoiceDate?.month
        || !mockResult.invoiceDate?.year
      ),
      invAmount: !mockResult.invAmount,
      directShip: !this.form.get('directShip')?.value,
      transportMode: !matchedTransportMode,
      exitPoint: !matchedExitPoint,
      shippingFrom: !matchedShippingFrom,
      portOfDischarge: !matchedPortOfDischarge
    });

    if (mockResult.invoiceDateOutOfRange && mockResult.invoiceDateRaw) {
      this.setInvoiceOcrDateOutOfRangeError(mockResult.invoiceDateRaw);
    }

    const ocrProductHsCodes = (mockResult.products || [])
      .map((product) => product.hsCode)
      .filter((hsCode): hsCode is string => !!hsCode);

    if (ocrProductHsCodes.length) {
      this.loadingOcrProductHsLookup = ocrProductHsCodes.length > 10;
      try {
        await this.getHSCodeName(ocrProductHsCodes);
      } finally {
        this.loadingOcrProductHsLookup = false;
      }
    }

    const mappedProducts = this.mapInvoiceOcrProducts(mockResult.products || []);
    this.showInvoiceOcrMissingProductCountryWarning = this.hasMissingProductCountryFromOcr(mockResult.products || []);
    this.products = mappedProducts;
    this.form.get('products')?.setValue(mappedProducts.length ? 'selected' : '');
    this.syncInvoiceOcrProductGuidance();
    this.clearProductValidationError();
    if (mappedProducts.length) {
      this.loadPage(1);
      this.updateDocumentMandatory(true);
      this.makeOthersDocumentMandatory();
    } else {
      this.currentPage = 1;
    }

    this.form.get('invoiceNo')?.markAsDirty();
    this.form.get('invoiceDate')?.markAsTouched();
    this.form.get('invoiceDate')?.markAsDirty();
    this.form.get('invoiceDate')?.get('year')?.markAsDirty();
    this.form.get('invCurrency')?.markAsDirty();
    this.form.get('invAmount')?.markAsDirty();
    this.form.get('invoiceNo')?.updateValueAndValidity();
    if (!mockResult.invoiceDateOutOfRange) {
      this.form.get('invoiceDate')?.updateValueAndValidity();
    }
    this.form.get('invAmount')?.updateValueAndValidity();
    this.setInvoiceOcrFieldAccess(true);
    this.validateInvocieNumber(null);
    this.validateAmount();
  }

  onInvoiceOcrFilesReadyForUpload(files: File[]) {
    this.pendingInvoiceOcrFilesForUpload = [...files];
    this.tryAutoUploadInvoiceOcrFiles();
  }

  private mapInvoiceOcrProducts(products: InvoiceOcrExtractedProduct[]): any[] {
    return products.map((product, index) => {
      const matchedHsCode = this.getMatchedHsCode(product.hsCode);

      return this.applyProductValidationState({
        id: `ocr-product-${Date.now()}-${index}`,
        isOcrImported: true,
        country: product.country || '',
        unit: product.unit || '',
        quantity: product.quantity || '',
        productHSCode: matchedHsCode?.code || product.hsCode || '',
        productNameEn: matchedHsCode?.name || '',
        productNameAr: matchedHsCode?.description || '',
        unitPrice: '',
        category: '',
        weight: '',
        processingType: '',
        processingCountry: ''
      });
    });
  }

  async getHSCodeName(productCodes: string | string[] | undefined): Promise<any[]> {
    const normalizedCodes = (Array.isArray(productCodes) ? productCodes : [productCodes])
      .map((code) => (code || '').toString().trim())
      .filter((code, index, arr) => !!code && arr.indexOf(code) === index);

    if (!normalizedCodes.length) {
      this.OCRProductHSCode = [];
      return this.OCRProductHSCode;
    }

    const hasCompleteMasterHsCodeList =
      Array.isArray(this.masterHSCodeList)
      && this.masterHSCodeList.length > 0
      && this.totalHsRecords > 0
      && this.masterHSCodeList.length === this.totalHsRecords;

    if (hasCompleteMasterHsCodeList) {
      this.OCRProductHSCode = this.masterHSCodeList.filter((hsCode: any) =>
        normalizedCodes.includes((hsCode?.code || '').toString().trim())
      );
      return this.OCRProductHSCode;
    }

    const hsCodeRequests = normalizedCodes.map(async (productCode) => {
      const hsCodeRequest = new HSCodeRequest();
      const product = hsCodeRequest.body.IncomingHierarchy.ListOfDCHSCODELIST.PRODUCT;
      product.ProductCode = productCode;
      product.Description = '';
      hsCodeRequest.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();
      hsCodeRequest.body.StartRowNum = 0;
      hsCodeRequest.body.PageSize = '2';
      hsCodeRequest.body.NewQuery = 'true';
      hsCodeRequest.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';

      const response: any = await lastValueFrom(
        this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_HS_CODE, hsCodeRequest)
      );

      const hsProducts = Utils.checkIsArray(response?.SiebelMessage?.['PRODUCT']);
      return hsProducts.map((hs: any, index: number) => ({
        id: index + 1,
        code: hs.ProductCode,
        name: hs.Description,
        description: hs.ProductNameARA,
      }));
    });

    const hsCodeResults = await Promise.all(hsCodeRequests);
    this.OCRProductHSCode = hsCodeResults.flat();
    return this.OCRProductHSCode;
  }

  private getMatchedControlLovValue(controlName: string, rawValue: string | undefined): string | null {
    const control = this.form.get(controlName);
    const fieldOptions = this.optionFields?.find((field) => field.control === control)?.options;
    return this.getMatchedLovValue(rawValue, fieldOptions);
  }

  private getMatchedLovValue(rawValue: string | undefined, options: any[] | undefined | null): string | null {
    const normalizedTarget = this.normalizeLovValue(rawValue);
    if (!normalizedTarget || !options?.length) {
      return null;
    }

    const matchedOption = options.find((option: any) => {
      const candidateValues = [
        option?.Value,
        option?.Name,
        option?.Description
      ];

      return candidateValues.some((candidate) => this.normalizeLovValue(candidate) === normalizedTarget);
    });

    return matchedOption ? (matchedOption.Value ?? matchedOption.Name ?? null) : null;
  }

  private getMatchedCountryValue(rawValue: string | undefined): string | null {
    const normalizedTarget = this.normalizeLovValue(rawValue);
    if (!normalizedTarget) {
      return null;
    }

    const countryOptions = this.optionFields
      ?.toArray()
      ?.find((field: any) => field?.lovType === LookupKey.COUNTRY)
      ?.options;

    const matchedLovCountry = countryOptions?.find((country: any) => {
      const candidateValues = [
        country?.Name,
        country?.Value
      ];

      return candidateValues.some(
        (candidate) => this.normalizeLovValue(candidate) === normalizedTarget
      );
    });

    if (matchedLovCountry) {
      return matchedLovCountry.Value ?? matchedLovCountry.Name ?? null;
    }

    return null;
  }

  private getMatchedHsCode(rawValue: string | undefined): any | null {
    const normalizedTarget = this.normalizeLovValue(rawValue);
    const hsCodeSource = this.OCRProductHSCode?.length ? this.OCRProductHSCode : this.masterHSCodeList;

    if (!normalizedTarget || !hsCodeSource?.length) {
      return null;
    }

    return hsCodeSource.find((hsCode: any) => {
      return this.normalizeLovValue(hsCode.code) === normalizedTarget
        || this.normalizeLovValue(hsCode.name) === normalizedTarget;
    }) || null;
  }

  private normalizeLovValue(value: unknown): string {
    return (value ?? '').toString().trim().toLowerCase();
  }

  private applyInvoiceOcrMissingState(missingMap: Record<string, boolean>) {
    Object.entries(missingMap).forEach(([controlName, isMissing]) => {
      const control = this.form.get(controlName);
      if (!control) {
        return;
      }

      if (!isMissing) {
        this.clearInvoiceOcrMissingError(controlName);
        return;
      }

      control.setErrors({
        ...(control.errors || {}),
        ocrMissing: true
      });
      control.markAsTouched();
      control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    });
  }

  private clearInvoiceOcrMissingState() {
    [
      'invoiceNo',
      'invoiceDate',
      'invAmount',
      'directShip',
      'transportMode',
      'exitPoint',
      'shippingFrom',
      'portOfDischarge'
    ].forEach((controlName) => this.clearInvoiceOcrMissingError(controlName));
    this.clearInvoiceOcrDateOutOfRangeError();
  }

  private clearInvoiceOcrMissingError(controlName: string) {
    const control = this.form.get(controlName);
    if (!control?.errors?.['ocrMissing']) {
      return;
    }

    const nextErrors = { ...(control.errors || {}) };
    delete nextErrors['ocrMissing'];
    control.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
    control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }

  private registerInvoiceOcrMissingFieldListeners() {
    [
      'invoiceNo',
      'invoiceDate',
      'invAmount',
      'directShip',
      'transportMode',
      'exitPoint',
      'shippingFrom',
      'portOfDischarge'
    ].forEach((controlName) => {
      this.form.get(controlName)?.valueChanges.subscribe(() => {
        this.clearInvoiceOcrMissingError(controlName);
      });
    });

    this.form.get('invoiceDate')?.valueChanges.subscribe(() => {
      this.clearInvoiceOcrDateOutOfRangeError();
    });
  }

  private initializeInvoiceOcrValidationMessages() {
    this.invoiceOcrMissingValidationMessages = {
      ocrMissing: this.translateService.instant('COO.OCR.MISSING_FIELD_REQUIRED')
    };
  }

  private setInvoiceOcrDateOutOfRangeError(invoiceDate: string) {
    const control = this.form.get('invoiceDate');
    if (!control) {
      return;
    }

    this.clearInvoiceOcrMissingError('invoiceDate');

    this.invoiceOcrMissingValidationMessages = {
      ...this.invoiceOcrMissingValidationMessages,
      ocrDateOutOfRange: this.translateService.instant('COO.OCR.DATE_OUT_OF_RANGE', {
        date: invoiceDate
      })
    };

    control.setErrors({
      ...(control.errors || {}),
      ocrDateOutOfRange: true
    });
    ['day', 'month', 'year'].forEach((fieldName) => {
      const fieldControl = control.get(fieldName);
      if (!fieldControl) {
        return;
      }

      fieldControl.setErrors({
        ...(fieldControl.errors || {}),
        ocrDateOutOfRange: true
      });
      fieldControl.markAsTouched();
      fieldControl.markAsDirty();
    });
    control.markAsTouched();
    control.markAsDirty();
  }

  private clearInvoiceOcrDateOutOfRangeError() {
    const control = this.form.get('invoiceDate');
    if (!control) {
      return;
    }

    const clearControlError = (targetControl: any) => {
      if (!targetControl?.errors?.['ocrDateOutOfRange']) {
        return;
      }

      const nextErrors = { ...(targetControl.errors || {}) };
      delete nextErrors['ocrDateOutOfRange'];
      targetControl.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
      targetControl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    };

    clearControlError(control);
    clearControlError(control.get('day'));
    clearControlError(control.get('month'));
    clearControlError(control.get('year'));
  }

  onInvoiceOcrCompletedChange(isCompleted: boolean) {
    this.showConfirmExtractedInvoice = isCompleted;
    const confirmExtractedInvoiceControl = this.form.get('confirmExtractedInvoice');

    if (isCompleted) {
      confirmExtractedInvoiceControl?.setValidators([Validators.requiredTrue]);
      confirmExtractedInvoiceControl?.updateValueAndValidity();
    }

    if (!isCompleted) {
      this.ocrExtractedInvoiceNumber = '';
      this.acknowledgedOcrInvoiceNumberMismatch = '';
      this.showInvoiceOcrInvoiceMismatchModal = false;
      confirmExtractedInvoiceControl?.setValue(false);
      confirmExtractedInvoiceControl?.clearValidators();
      confirmExtractedInvoiceControl?.updateValueAndValidity();
      this.clearInvoiceOcrMissingState();
      this.showInvoiceOcrProductFallbackGuidance = false;
      this.showInvoiceOcrMissingProductCountryWarning = false;
      this.clearProductValidationError();
    }

    this.setInvoiceOcrFieldAccess(isCompleted);
    this.syncInvoiceOcrProductGuidance();
  }

  onInvoiceOcrManualEntrySelected() {
    this.docAiScanFlag = 'N';
    this.ocrExtractedInvoiceNumber = '';
    this.acknowledgedOcrInvoiceNumberMismatch = '';
    this.showInvoiceOcrInvoiceMismatchModal = false;
    this.setInvoiceOcrFieldAccess(true);
    this.clearInvoiceOcrMissingState();
    this.showInvoiceOcrProductFallbackGuidance = false;
    this.showInvoiceOcrMissingProductCountryWarning = false;
    this.clearProductValidationError();
  }

  onInvoiceOcrRedoRequested() {
    this.ocrExtractedInvoiceNumber = '';
    this.acknowledgedOcrInvoiceNumberMismatch = '';
    this.showInvoiceOcrInvoiceMismatchModal = false;
    this.form.patchValue({
      invoiceNo: null,
      invoiceDate: { day: null, month: null, year: null },
      invAmount: null,
      directShip: null,
      transportMode: null,
      exitPoint: null,
      shippingFrom: null,
      portOfDischarge: null
    });

    this.products = [];
    this.visibleProducts = [];
    this.currentPage = 1;
    this.form.get('products')?.setValue('');

    [
      'invoiceNo',
      'invoiceDate',
      'invAmount',
      'directShip',
      'transportMode',
      'exitPoint',
      'shippingFrom',
      'portOfDischarge',
      'products'
    ].forEach((controlName) => {
      this.form.get(controlName)?.markAsDirty();
      this.form.get(controlName)?.updateValueAndValidity();
    });

    this.clearInvoiceOcrMissingState();
    this.syncInvoiceOcrProductGuidance();
    this.showInvoiceOcrMissingProductCountryWarning = false;
    this.clearProductValidationError();
    this.updateDocumentMandatory(true);
    this.makeOthersDocumentMandatory();
  }

  switchToGspAfterOcr() {
    this.persistInvoiceOcrTransfer();
    this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.COO.GSP_CERTIFICATE}`]);
  }

  private persistInvoiceOcrTransfer() {
      const invoiceDate = this.form.get('invoiceDate')?.value;
      const payload: InvoiceOcrTransferPayload = {
        invoiceNo: (this.form.get('invoiceNo')?.value || '').toString(),
        invoiceDate: {
        day: (invoiceDate?.day || '').toString(),
        month: (invoiceDate?.month || '').toString(),
        year: (invoiceDate?.year || '').toString()
        },
        invCurrency: (this.form.get('invCurrency')?.value || '').toString(),
        invAmount: (this.form.get('invAmount')?.value || '').toString(),
        shippingFrom: this.form.get('shippingFrom')?.value ?? null,
        countryDest: this.form.get('countryDest')?.value ?? null,
        portOfDischarge: this.form.get('portOfDischarge')?.value ?? null,
        products: [...(this.products || [])],
        startStep: 3
      };
      sessionStorage.setItem(
        CertificateOfOriginComponent.INVOICE_OCR_TRANSFER_KEY,
        JSON.stringify(payload)
      );
  }

  private applyPendingInvoiceOcrTransfer() {
    if (!this.isGspCertificate) {
      return;
    }

    const rawPayload = sessionStorage.getItem(CertificateOfOriginComponent.INVOICE_OCR_TRANSFER_KEY);
    if (!rawPayload) {
      return;
    }

      try {
        const payload = JSON.parse(rawPayload) as InvoiceOcrTransferPayload;
        this.form.patchValue({
          membershipId: this.membershipId || this.userCSN || null,
          invoiceNo: payload.invoiceNo || null,
          invoiceDate: payload.invoiceDate || { day: null, month: null, year: null },
          invCurrency: payload.invCurrency || null,
          invAmount: payload.invAmount || null,
          shippingFrom: payload.shippingFrom || null,
          countryDest: payload.countryDest || null,
          portOfDischarge: payload.portOfDischarge || null
        });
        this.products = [...(payload.products || [])];
        this.form.get('products')?.setValue(this.products.length > 0 ? 'selected' : '');
        if (this.products.length) {
          this.loadPage(1);
          this.updateDocumentMandatory(true);
          this.makeOthersDocumentMandatory();
        }
        this.step = payload.startStep || 3;
        this.setInvoiceOcrFieldAccess(true);
      } finally {
        sessionStorage.removeItem(CertificateOfOriginComponent.INVOICE_OCR_TRANSFER_KEY);
      }
    }

  private syncInvoiceOcrFieldAccess() {
    this.setInvoiceOcrFieldAccess(this.isInvoiceOcrEnabled ? !!this.srNumber : true);
  }

  private setInvoiceOcrFieldAccess(canEdit: boolean) {
    if (!this.isInvoiceOcrEnabled) {
      this.canEditInvoiceOcrFields = true;
      [
        'invoiceNo',
        'invoiceDate',
        'invAmount',
        'invCurrency',
        'directShip',
        'transportMode',
        'exitPoint',
        'shippingFrom',
        'portOfDischarge'
      ].forEach((controlName) => {
        this.form.get(controlName)?.enable({ emitEvent: controlName === 'invoiceDate' });
      });
      return;
    }

    this.canEditInvoiceOcrFields = canEdit || !!this.srNumber;

    const method = this.canEditInvoiceOcrFields ? 'enable' : 'disable';
    const controls = [
      'invoiceNo',
      'invoiceDate',
      'invAmount',
      'invCurrency',
      'directShip',
      'transportMode',
      'exitPoint',
      'shippingFrom',
      'portOfDischarge'
    ];

    controls.forEach((controlName) => {
      const control = this.form.get(controlName);
      if (!control) {
        return;
      }

      if (method === 'enable') {
        control.enable({ emitEvent: false });
        return;
      }

      control.disable({ emitEvent: false });
    });
  }

  // This method is used to auto upload the invoice ocr files
  private tryAutoUploadInvoiceOcrFiles() {
    if (this.isAutoUploadingInvoiceOcrFiles || !this.pendingInvoiceOcrFilesForUpload.length) {
      return;
    }

    const folder = this.srFolder;
    const documentType = CertificateOfOriginComponent.OCR_AUTO_UPLOAD_DOCUMENT_TYPE;
    const allowedDocType = folder?.allowedDocumentTypes?.find(
      (doc) => (doc?.nameEn || '').toLowerCase() === documentType.toLowerCase()
    );

    if (!folder?.folderId || !allowedDocType) {
      return;
    }

    const filesToUpload = allowedDocType.canUploadMultiple
      ? [...this.pendingInvoiceOcrFilesForUpload]
      : [this.pendingInvoiceOcrFilesForUpload[0]];

    this.isAutoUploadingInvoiceOcrFiles = true;

    this.sharedService
      .getEncryption(this.documentServiceType.COO, { cooMot: this.selectedModeOfTransfer, svsSubject: '', userType: 'Customer' })
      .subscribe({
        next: (encryptionResponse: EncryptionResponse) => {
          if (!encryptionResponse) {
            this.isAutoUploadingInvoiceOcrFiles = false;
            return;
          }

          const response: any = Utils.decodeAndStringify(encryptionResponse);
          this.removeExistingDocumentsBeforeOcrUpload(documentType, response.validation)
            .then((isRemoved) => {
              if (!isRemoved) {
                this.pendingInvoiceOcrFilesForUpload = [];
                this.isAutoUploadingInvoiceOcrFiles = false;
                return;
              }

          const uploadNext = (index: number) => {
            if (index >= filesToUpload.length) {
              this.pendingInvoiceOcrFilesForUpload = [];
              this.isAutoUploadingInvoiceOcrFiles = false;
              return;
            }

            const file = filesToUpload[index];
            const meta = {
              documentTypeNameEn: documentType,
              folderId: folder.folderId,
              folderParentId: folder.folderParentId,
              folderParentType: folder.folderParentType,
              serviceType: environment.documentEncryption ? response.serviceType : this.documentServiceType.COO,
              validation: environment.documentEncryption ? response.validation : Utils.getDubaiDateTime(),
              notes: '',
              mot: environment.documentEncryption ? response.mot : this.selectedModeOfTransfer ?? '',
              svsSubject: environment.documentEncryption ? response.svsSubject : '',
              userType: environment.documentEncryption ? response.userType : 'Customer',
              externalStampLoc: CertificateOfOriginComponent.OCR_AUTO_UPLOAD_STAMP_LOCATION
            };

            this.attachmentService
              .uploadFile(ApiRoot.JUPITER_REST, ApiEndPoints.UPLOAD_DOCUMENT, file, meta)
              .pipe(
                finalize(() => {
                  if (index === filesToUpload.length - 1) {
                    this.isAutoUploadingInvoiceOcrFiles = false;
                  }
                })
              )
              .subscribe({
                next: (event: any) => {
                  if (!event?.response?.data?.documentId) {
                    return;
                  }

                  const uploadedDocument = {
                    documentType,
                    documentId: event.response.data.documentId,
                    notes: '',
                    ocrAutoUploaded: true,
                    ...event.response.data,
                    canDelete: false
                  };

                  const nextDocuments = [...(this.srFolder?.documents || [])];
                  const hasSameDocument = nextDocuments.some(
                    (doc: any) => doc?.documentId === uploadedDocument.documentId
                  );

                  if (!hasSameDocument) {
                    nextDocuments.push(uploadedDocument);
                    this.srFolder = {
                      ...this.srFolder,
                      documents: nextDocuments
                    };
                    this.mainFromSectionDocs = [...(this.mainFromSectionDocs || [])];
                  }

                  uploadNext(index + 1);
                },
                error: () => {
                  this.isAutoUploadingInvoiceOcrFiles = false;
                }
              });
          };

          uploadNext(0);
            })
            .catch(() => {
              this.pendingInvoiceOcrFilesForUpload = [];
              this.isAutoUploadingInvoiceOcrFiles = false;
            });
        },
        error: () => {
          this.isAutoUploadingInvoiceOcrFiles = false;
        }
      });
  }
  // This method is used to remove the existing document before uploading the new document for invoice ocr
  private async removeExistingDocumentsBeforeOcrUpload(
    documentType: string,
    validation: string
  ): Promise<boolean> {
    const existingDocuments = this.getUploadedDocumentsByType(documentType);
    if (!existingDocuments.length) {
      return true;
    }

    const documentIds = existingDocuments
      .map((doc: any) => doc?.documentId)
      .filter((documentId: any) => !!documentId);

    if (!documentIds.length || !this.srFolder?.folderId) {
      this.srFolder = {
        ...this.srFolder,
        documents: (this.srFolder?.documents || []).filter(
          (doc: any) => (doc?.documentType || '').toLowerCase() !== documentType.toLowerCase()
        )
      };
      this.mainFromSectionDocs = [...(this.mainFromSectionDocs || [])];
      return true;
    }

    await lastValueFrom(
      this.attachmentService.deleteBulkDocuments(ApiRoot.JUPITER_REST, ApiEndPoints.DELETE_BULK_DOCUMENT, {
        documentIds,
        folderId: this.srFolder.folderId,
        folderParentId: this.srFolder.folderParentId,
        folderParentType: this.srFolder.folderParentType,
        validation: environment.documentEncryption ? validation : ''
      })
    );

    this.srFolder = {
      ...this.srFolder,
      documents: (this.srFolder?.documents || []).filter(
        (doc: any) => !documentIds.includes(doc?.documentId)
      )
    };
    this.mainFromSectionDocs = [...(this.mainFromSectionDocs || [])];
    return true;
  }
}
